"use strict";
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityDocumentScalarFieldEnum = exports.FacilityCredentialScalarFieldEnum = exports.FacilityContactScalarFieldEnum = exports.FacilityChemicalStorageLocationScalarFieldEnum = exports.FacilityChemicalStateFieldScalarFieldEnum = exports.FacilityChemicalMeasurementScalarFieldEnum = exports.FacilityChemicalScalarFieldEnum = exports.FacilityAlternateIdScalarFieldEnum = exports.FacilityScalarFieldEnum = exports.CalculationOperationScalarFieldEnum = exports.CalculatedRegulatoryStatusScalarFieldEnum = exports.ErrorClusterScalarFieldEnum = exports.EmulatedRoleScalarFieldEnum = exports.EManifestSiteSyncScalarFieldEnum = exports.DocumentTagScalarFieldEnum = exports.DocumentMetadataScalarFieldEnum = exports.DocumentScalarFieldEnum = exports.DataLedgerScalarFieldEnum = exports.OneTimePasswordScalarFieldEnum = exports.CredentialUsageLogScalarFieldEnum = exports.CredentialScalarFieldEnum = exports.AlternateIdInfoScalarFieldEnum = exports.AlternateIdCredentialScalarFieldEnum = exports.ComplianceQuarterScalarFieldEnum = exports.SendGridEmailScalarFieldEnum = exports.LobMailScalarFieldEnum = exports.LobAddressScalarFieldEnum = exports.CommunicationFacilityScalarFieldEnum = exports.CommunicationDocumentScalarFieldEnum = exports.CommunicationScalarFieldEnum = exports.CommentScalarFieldEnum = exports.CohortMemberScalarFieldEnum = exports.CohortScalarFieldEnum = exports.ChemicalTenantScalarFieldEnum = exports.ChemicalStateFieldScalarFieldEnum = exports.ChemicalMapScalarFieldEnum = exports.ChemicalDocumentScalarFieldEnum = exports.ChemicalComponentScalarFieldEnum = exports.ChemicalScalarFieldEnum = exports.AuditedTableScalarFieldEnum = exports.AuditScalarFieldEnum = exports.RelationLoadStrategy = exports.AiUsageTrackingScalarFieldEnum = exports.TransactionIsolationLevel = exports.ModelName = exports.AnyNull = exports.JsonNull = exports.DbNull = exports.NullTypes = exports.Decimal = void 0;
exports.EchoRcraVioSncHistoryScalarFieldEnum = exports.EchoRcraFacilityScalarFieldEnum = exports.NpdesQncrHistoryScalarFieldEnum = exports.NpdesPermitScalarFieldEnum = exports.NpdesFacilityScalarFieldEnum = exports.NpdesSeViolationScalarFieldEnum = exports.NpdesPsViolationScalarFieldEnum = exports.NpdesEffViolationScalarFieldEnum = exports.NpdesCsViolationScalarFieldEnum = exports.EchoFacilityMatchCandidateScalarFieldEnum = exports.EchoExporterScalarFieldEnum = exports.CaseMilestonesScalarFieldEnum = exports.CaseEnforcementConclusionComplyingActionsScalarFieldEnum = exports.CaseEnforcementConclusionSepScalarFieldEnum = exports.CaseReliefSoughtScalarFieldEnum = exports.CaseRegionalDocketsScalarFieldEnum = exports.IcisFecEpaInspectionsScalarFieldEnum = exports.CaseEnforcementConclusionDollarsScalarFieldEnum = exports.CaseEnforcementConclusionFacilitiesScalarFieldEnum = exports.CaseRelatedActivitiesScalarFieldEnum = exports.CaseDefendantsScalarFieldEnum = exports.CaseFacilitiesScalarFieldEnum = exports.CasePenaltiesScalarFieldEnum = exports.EpaInformalEnforcementActionsScalarFieldEnum = exports.CaseEnforcementConclusionPollutantsScalarFieldEnum = exports.CaseViolationsScalarFieldEnum = exports.CaseLawSectionsScalarFieldEnum = exports.CasePollutantsScalarFieldEnum = exports.CasePrioritiesScalarFieldEnum = exports.CaseEnforcementTypeScalarFieldEnum = exports.CaseEnforcementConclusionsScalarFieldEnum = exports.CaseProgramsScalarFieldEnum = exports.CaseEnforcementsScalarFieldEnum = exports.EchoAirViolationHistoryScalarFieldEnum = exports.EchoAirFacilityScalarFieldEnum = exports.FireDepartmentScalarFieldEnum = exports.ThresholdResultScalarFieldEnum = exports.ReportingFacilityChemicalThresholdResultScalarFieldEnum = exports.ReportingFacilityChemicalStorageLocationScalarFieldEnum = exports.ReportingFacilityChemicalOriginScalarFieldEnum = exports.ReportingFacilityChemicalScalarFieldEnum = exports.ProcessedManifestScalarFieldEnum = exports.FacilityTagScalarFieldEnum = exports.FacilityStateFieldScalarFieldEnum = exports.FacilityProductStorageLocationScalarFieldEnum = exports.FacilityProductMeasurementScalarFieldEnum = exports.FacilityProductScalarFieldEnum = exports.FacilityPilotProgramLocalScalarFieldEnum = exports.FacilityPilotProgramScalarFieldEnum = exports.FacilityPaymentScalarFieldEnum = void 0;
exports.TaskScalarFieldEnum = exports.TagScalarFieldEnum = exports.SupplementalLepcScalarFieldEnum = exports.SupplementalFireDepartmentScalarFieldEnum = exports.SubmissionTagScalarFieldEnum = exports.SubmissionReviewerScalarFieldEnum = exports.SubmissionPaymentScalarFieldEnum = exports.SubmissionDocumentReviewScalarFieldEnum = exports.SubmissionDocumentScalarFieldEnum = exports.SubmissionScalarFieldEnum = exports.FacilitySubmissionScalarFieldEnum = exports.StorageLocationScalarFieldEnum = exports.SnapshotScalarFieldEnum = exports.SercAgencyScalarFieldEnum = exports.RoleScalarFieldEnum = exports.ProductTenantScalarFieldEnum = exports.ProductChemicalOverrideScalarFieldEnum = exports.ProductChemicalScalarFieldEnum = exports.ProductScalarFieldEnum = exports.PortalScalarFieldEnum = exports.PoliceDepartmentScalarFieldEnum = exports.PipelineScalarFieldEnum = exports.PersonScalarFieldEnum = exports.PaymentReconciliationHistoryScalarFieldEnum = exports.PaymentInvoiceScalarFieldEnum = exports.PaymentCommentScalarFieldEnum = exports.PaymentScalarFieldEnum = exports.OneSchemaImportScalarFieldEnum = exports.NotificationScalarFieldEnum = exports.MergeRecordScalarFieldEnum = exports.LockScalarFieldEnum = exports.LinearWebhookEventScalarFieldEnum = exports.LepcScalarFieldEnum = exports.LeadAgencyScalarFieldEnum = exports.JobManagerConfigScalarFieldEnum = exports.JobScalarFieldEnum = exports.JobStepsDoneScalarFieldEnum = exports.JobLogScalarFieldEnum = exports.ModelIssueScalarFieldEnum = exports.FacilityModelIssueCountScalarFieldEnum = exports.FacilityModelIssueScalarFieldEnum = exports.WasteTransporterScalarFieldEnum = exports.WasteManifestScalarFieldEnum = exports.WasteLineTagScalarFieldEnum = exports.WasteLineScalarFieldEnum = exports.HdOwnerOperatorScalarFieldEnum = exports.HdHandlerScalarFieldEnum = exports.InsightsCohortScalarFieldEnum = exports.NationalContactFileScalarFieldEnum = exports.EchoRcraViolationScalarFieldEnum = void 0;
exports.SortOrder = exports.TierIIReportActivityScalarFieldEnum = exports.SnapshotReportingFacilityChemicalScalarFieldEnum = exports.FacilityTierIIReportScalarFieldEnum = exports.FacilityRCRAInfoExporterScalarFieldEnum = exports.FacilityEchoExporterScalarFieldEnum = exports.FacilityEPAIdsScalarFieldEnum = exports.ProcessedManifestViewScalarFieldEnum = exports.EchoExporterAggregatedScalarFieldEnum = exports.ChemicalAnomalyScalarFieldEnum = exports.ZipCodeScalarFieldEnum = exports.WorkflowTagScalarFieldEnum = exports.WorkflowManagerConfigScalarFieldEnum = exports.WorkflowScalarFieldEnum = exports.ActivityDocumentScalarFieldEnum = exports.ActivityCohortScalarFieldEnum = exports.ActivityUserInputScalarFieldEnum = exports.ActivityLogScalarFieldEnum = exports.ActivityScalarFieldEnum = exports.WasteStreamRawScalarFieldEnum = exports.WasteStreamScalarFieldEnum = exports.WasteManifestVendorScalarFieldEnum = exports.WasteLineUnifiedTagScalarFieldEnum = exports.WasteLineUnifiedScalarFieldEnum = exports.StateWasteCodeScalarFieldEnum = exports.IngestSummaryScalarFieldEnum = exports.FacilityWasteStreamYearToDateScalarFieldEnum = exports.FacilityWasteStreamAmountScalarFieldEnum = exports.FacilityWasteStreamScalarFieldEnum = exports.UserTenantScalarFieldEnum = exports.UserLoginScalarFieldEnum = exports.UserFacilityScalarFieldEnum = exports.UserCognitoScalarFieldEnum = exports.UserCalendarTokenScalarFieldEnum = exports.UserScalarFieldEnum = exports.UndergroundStorageTankCertificationScalarFieldEnum = exports.UndergroundStorageTankScalarFieldEnum = exports.TierIIReportValidationScalarFieldEnum = exports.TierIIReportUstStatusScalarFieldEnum = exports.TierIIReportSubmissionMeasureScalarFieldEnum = exports.TierIIReportStatusLogScalarFieldEnum = exports.TierIIReportPaymentScalarFieldEnum = exports.TierIIReportAssigneeScalarFieldEnum = exports.TierIIReportScalarFieldEnum = exports.ReportFacilityDocumentScalarFieldEnum = exports.TenantContactScalarFieldEnum = exports.TenantConfigScalarFieldEnum = exports.TenantScalarFieldEnum = exports.TaskTagScalarFieldEnum = exports.SubTaskScalarFieldEnum = void 0;
exports.NullsOrder = exports.JsonNullValueFilter = exports.QueryMode = exports.JsonNullValueInput = exports.NullableJsonNullValueInput = void 0;
const runtime = __importStar(require("@prisma/client/runtime/index-browser"));
exports.Decimal = runtime.Decimal;
exports.NullTypes = {
    DbNull: runtime.NullTypes.DbNull,
    JsonNull: runtime.NullTypes.JsonNull,
    AnyNull: runtime.NullTypes.AnyNull,
};
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
exports.DbNull = runtime.DbNull;
/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
exports.JsonNull = runtime.JsonNull;
/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
exports.AnyNull = runtime.AnyNull;
exports.ModelName = {
    AiUsageTracking: 'AiUsageTracking',
    Audit: 'Audit',
    AuditedTable: 'AuditedTable',
    Chemical: 'Chemical',
    ChemicalComponent: 'ChemicalComponent',
    ChemicalDocument: 'ChemicalDocument',
    ChemicalMap: 'ChemicalMap',
    ChemicalStateField: 'ChemicalStateField',
    ChemicalTenant: 'ChemicalTenant',
    Cohort: 'Cohort',
    CohortMember: 'CohortMember',
    Comment: 'Comment',
    Communication: 'Communication',
    CommunicationDocument: 'CommunicationDocument',
    CommunicationFacility: 'CommunicationFacility',
    LobAddress: 'LobAddress',
    LobMail: 'LobMail',
    SendGridEmail: 'SendGridEmail',
    ComplianceQuarter: 'ComplianceQuarter',
    AlternateIdCredential: 'AlternateIdCredential',
    AlternateIdInfo: 'AlternateIdInfo',
    Credential: 'Credential',
    CredentialUsageLog: 'CredentialUsageLog',
    OneTimePassword: 'OneTimePassword',
    DataLedger: 'DataLedger',
    Document: 'Document',
    DocumentMetadata: 'DocumentMetadata',
    DocumentTag: 'DocumentTag',
    eManifestSiteSync: 'eManifestSiteSync',
    EmulatedRole: 'EmulatedRole',
    ErrorCluster: 'ErrorCluster',
    CalculatedRegulatoryStatus: 'CalculatedRegulatoryStatus',
    CalculationOperation: 'CalculationOperation',
    Facility: 'Facility',
    FacilityAlternateId: 'FacilityAlternateId',
    FacilityChemical: 'FacilityChemical',
    FacilityChemicalMeasurement: 'FacilityChemicalMeasurement',
    FacilityChemicalStateField: 'FacilityChemicalStateField',
    FacilityChemicalStorageLocation: 'FacilityChemicalStorageLocation',
    FacilityContact: 'FacilityContact',
    FacilityCredential: 'FacilityCredential',
    FacilityDocument: 'FacilityDocument',
    FacilityPayment: 'FacilityPayment',
    FacilityPilotProgram: 'FacilityPilotProgram',
    FacilityPilotProgramLocal: 'FacilityPilotProgramLocal',
    FacilityProduct: 'FacilityProduct',
    FacilityProductMeasurement: 'FacilityProductMeasurement',
    FacilityProductStorageLocation: 'FacilityProductStorageLocation',
    FacilityStateField: 'FacilityStateField',
    FacilityTag: 'FacilityTag',
    ProcessedManifest: 'ProcessedManifest',
    ReportingFacilityChemical: 'ReportingFacilityChemical',
    ReportingFacilityChemicalOrigin: 'ReportingFacilityChemicalOrigin',
    ReportingFacilityChemicalStorageLocation: 'ReportingFacilityChemicalStorageLocation',
    ReportingFacilityChemicalThresholdResult: 'ReportingFacilityChemicalThresholdResult',
    ThresholdResult: 'ThresholdResult',
    FireDepartment: 'FireDepartment',
    EchoAirFacility: 'EchoAirFacility',
    EchoAirViolationHistory: 'EchoAirViolationHistory',
    CaseEnforcements: 'CaseEnforcements',
    CasePrograms: 'CasePrograms',
    CaseEnforcementConclusions: 'CaseEnforcementConclusions',
    CaseEnforcementType: 'CaseEnforcementType',
    CasePriorities: 'CasePriorities',
    CasePollutants: 'CasePollutants',
    CaseLawSections: 'CaseLawSections',
    CaseViolations: 'CaseViolations',
    CaseEnforcementConclusionPollutants: 'CaseEnforcementConclusionPollutants',
    EpaInformalEnforcementActions: 'EpaInformalEnforcementActions',
    CasePenalties: 'CasePenalties',
    CaseFacilities: 'CaseFacilities',
    CaseDefendants: 'CaseDefendants',
    CaseRelatedActivities: 'CaseRelatedActivities',
    CaseEnforcementConclusionFacilities: 'CaseEnforcementConclusionFacilities',
    CaseEnforcementConclusionDollars: 'CaseEnforcementConclusionDollars',
    IcisFecEpaInspections: 'IcisFecEpaInspections',
    CaseRegionalDockets: 'CaseRegionalDockets',
    CaseReliefSought: 'CaseReliefSought',
    CaseEnforcementConclusionSep: 'CaseEnforcementConclusionSep',
    CaseEnforcementConclusionComplyingActions: 'CaseEnforcementConclusionComplyingActions',
    CaseMilestones: 'CaseMilestones',
    EchoExporter: 'EchoExporter',
    EchoFacilityMatchCandidate: 'EchoFacilityMatchCandidate',
    NpdesCsViolation: 'NpdesCsViolation',
    NpdesEffViolation: 'NpdesEffViolation',
    NpdesPsViolation: 'NpdesPsViolation',
    NpdesSeViolation: 'NpdesSeViolation',
    NpdesFacility: 'NpdesFacility',
    NpdesPermit: 'NpdesPermit',
    NpdesQncrHistory: 'NpdesQncrHistory',
    EchoRcraFacility: 'EchoRcraFacility',
    EchoRcraVioSncHistory: 'EchoRcraVioSncHistory',
    EchoRcraViolation: 'EchoRcraViolation',
    NationalContactFile: 'NationalContactFile',
    InsightsCohort: 'InsightsCohort',
    HdHandler: 'HdHandler',
    HdOwnerOperator: 'HdOwnerOperator',
    WasteLine: 'WasteLine',
    WasteLineTag: 'WasteLineTag',
    WasteManifest: 'WasteManifest',
    WasteTransporter: 'WasteTransporter',
    FacilityModelIssue: 'FacilityModelIssue',
    FacilityModelIssueCount: 'FacilityModelIssueCount',
    ModelIssue: 'ModelIssue',
    JobLog: 'JobLog',
    JobStepsDone: 'JobStepsDone',
    Job: 'Job',
    JobManagerConfig: 'JobManagerConfig',
    LeadAgency: 'LeadAgency',
    Lepc: 'Lepc',
    LinearWebhookEvent: 'LinearWebhookEvent',
    Lock: 'Lock',
    MergeRecord: 'MergeRecord',
    Notification: 'Notification',
    OneSchemaImport: 'OneSchemaImport',
    Payment: 'Payment',
    PaymentComment: 'PaymentComment',
    PaymentInvoice: 'PaymentInvoice',
    PaymentReconciliationHistory: 'PaymentReconciliationHistory',
    Person: 'Person',
    Pipeline: 'Pipeline',
    PoliceDepartment: 'PoliceDepartment',
    Portal: 'Portal',
    Product: 'Product',
    ProductChemical: 'ProductChemical',
    ProductChemicalOverride: 'ProductChemicalOverride',
    ProductTenant: 'ProductTenant',
    Role: 'Role',
    SercAgency: 'SercAgency',
    Snapshot: 'Snapshot',
    StorageLocation: 'StorageLocation',
    FacilitySubmission: 'FacilitySubmission',
    Submission: 'Submission',
    SubmissionDocument: 'SubmissionDocument',
    SubmissionDocumentReview: 'SubmissionDocumentReview',
    SubmissionPayment: 'SubmissionPayment',
    SubmissionReviewer: 'SubmissionReviewer',
    SubmissionTag: 'SubmissionTag',
    SupplementalFireDepartment: 'SupplementalFireDepartment',
    SupplementalLepc: 'SupplementalLepc',
    Tag: 'Tag',
    Task: 'Task',
    SubTask: 'SubTask',
    TaskTag: 'TaskTag',
    Tenant: 'Tenant',
    TenantConfig: 'TenantConfig',
    TenantContact: 'TenantContact',
    ReportFacilityDocument: 'ReportFacilityDocument',
    TierIIReport: 'TierIIReport',
    TierIIReportAssignee: 'TierIIReportAssignee',
    TierIIReportPayment: 'TierIIReportPayment',
    TierIIReportStatusLog: 'TierIIReportStatusLog',
    TierIIReportSubmissionMeasure: 'TierIIReportSubmissionMeasure',
    TierIIReportUstStatus: 'TierIIReportUstStatus',
    TierIIReportValidation: 'TierIIReportValidation',
    UndergroundStorageTank: 'UndergroundStorageTank',
    UndergroundStorageTankCertification: 'UndergroundStorageTankCertification',
    User: 'User',
    UserCalendarToken: 'UserCalendarToken',
    UserCognito: 'UserCognito',
    UserFacility: 'UserFacility',
    UserLogin: 'UserLogin',
    UserTenant: 'UserTenant',
    FacilityWasteStream: 'FacilityWasteStream',
    FacilityWasteStreamAmount: 'FacilityWasteStreamAmount',
    FacilityWasteStreamYearToDate: 'FacilityWasteStreamYearToDate',
    IngestSummary: 'IngestSummary',
    StateWasteCode: 'StateWasteCode',
    WasteLineUnified: 'WasteLineUnified',
    WasteLineUnifiedTag: 'WasteLineUnifiedTag',
    WasteManifestVendor: 'WasteManifestVendor',
    WasteStream: 'WasteStream',
    WasteStreamRaw: 'WasteStreamRaw',
    Activity: 'Activity',
    ActivityLog: 'ActivityLog',
    ActivityUserInput: 'ActivityUserInput',
    ActivityCohort: 'ActivityCohort',
    ActivityDocument: 'ActivityDocument',
    Workflow: 'Workflow',
    WorkflowManagerConfig: 'WorkflowManagerConfig',
    WorkflowTag: 'WorkflowTag',
    ZipCode: 'ZipCode',
    ChemicalAnomaly: 'ChemicalAnomaly',
    EchoExporterAggregated: 'EchoExporterAggregated',
    ProcessedManifestView: 'ProcessedManifestView',
    FacilityEPAIds: 'FacilityEPAIds',
    FacilityEchoExporter: 'FacilityEchoExporter',
    FacilityRCRAInfoExporter: 'FacilityRCRAInfoExporter',
    FacilityTierIIReport: 'FacilityTierIIReport',
    SnapshotReportingFacilityChemical: 'SnapshotReportingFacilityChemical',
    TierIIReportActivity: 'TierIIReportActivity'
};
/*
 * Enums
 */
exports.TransactionIsolationLevel = runtime.makeStrictEnum({
    ReadUncommitted: 'ReadUncommitted',
    ReadCommitted: 'ReadCommitted',
    RepeatableRead: 'RepeatableRead',
    Serializable: 'Serializable'
});
exports.AiUsageTrackingScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    provider: 'provider',
    model: 'model',
    inputTokens: 'inputTokens',
    outputTokens: 'outputTokens',
    cachedInputTokens: 'cachedInputTokens',
    totalTokens: 'totalTokens',
    estimatedCost: 'estimatedCost',
    tenantId: 'tenantId',
    documentId: 'documentId',
    userId: 'userId',
    operation: 'operation',
    duration: 'duration',
    metadata: 'metadata'
};
exports.RelationLoadStrategy = {
    query: 'query',
    join: 'join'
};
exports.AuditScalarFieldEnum = {
    auditId: 'auditId',
    recordId: 'recordId',
    operation: 'operation',
    timestamp: 'timestamp',
    user: 'user',
    session: 'session',
    tableOid: 'tableOid',
    tableSchema: 'tableSchema',
    tableName: 'tableName',
    record: 'record',
    oldRecord: 'oldRecord'
};
exports.AuditedTableScalarFieldEnum = {
    id: 'id',
    tableName: 'tableName',
    shouldAudit: 'shouldAudit',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalScalarFieldEnum = {
    id: 'id',
    needsReview: 'needsReview',
    name: 'name',
    casNumber: 'casNumber',
    normalizedCasNumber: 'normalizedCasNumber',
    noCasNumber: 'noCasNumber',
    alternateId: 'alternateId',
    isEhs: 'isEhs',
    pureOrMixture: 'pureOrMixture',
    stateOfMatter: 'stateOfMatter',
    isTradeSecret: 'isTradeSecret',
    density: 'density',
    densityUnits: 'densityUnits',
    manufacturerSupplier: 'manufacturerSupplier',
    recommendedUse: 'recommendedUse',
    version: 'version',
    revisionDate: 'revisionDate',
    physicalHazards: 'physicalHazards',
    healthHazards: 'healthHazards',
    oregonHazards: 'oregonHazards',
    ifcHazards: 'ifcHazards',
    noHazardsNotReporting: 'noHazardsNotReporting',
    ehsForm: 'ehsForm',
    createdAtViaMerge: 'createdAtViaMerge',
    verifiedAt: 'verifiedAt',
    verifiedBy: 'verifiedBy',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalComponentScalarFieldEnum = {
    id: 'id',
    chemicalId: 'chemicalId',
    name: 'name',
    casNumber: 'casNumber',
    normalizedCasNumber: 'normalizedCasNumber',
    noCasNumber: 'noCasNumber',
    isEhs: 'isEhs',
    componentPercentage: 'componentPercentage',
    weightOrVolume: 'weightOrVolume',
    ehsForm: 'ehsForm',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalDocumentScalarFieldEnum = {
    id: 'id',
    key: 'key',
    name: 'name',
    documentId: 'documentId',
    chemicalId: 'chemicalId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalMapScalarFieldEnum = {
    id: 'id',
    state: 'state',
    chemicalId: 'chemicalId',
    encampName: 'encampName',
    encampCasNumber: 'encampCasNumber',
    agencyChemicalId: 'agencyChemicalId',
    mappedName: 'mappedName',
    mappedCasNumber: 'mappedCasNumber',
    mappedEhs: 'mappedEhs',
    tenantName: 'tenantName',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalStateFieldScalarFieldEnum = {
    id: 'id',
    chemicalId: 'chemicalId',
    key: 'key',
    value: 'value',
    type: 'type',
    jurisdiction: 'jurisdiction',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalTenantScalarFieldEnum = {
    id: 'id',
    chemicalId: 'chemicalId',
    tenantId: 'tenantId'
};
exports.CohortScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    partnerTenantId: 'partnerTenantId',
    reportingYear: 'reportingYear',
    type: 'type',
    status: 'status',
    errorMessage: 'errorMessage',
    multiCohortOverrideReason: 'multiCohortOverrideReason',
    currentWorkflowId: 'currentWorkflowId',
    fdId: 'fdId',
    lepcId: 'lepcId',
    credentialUsername: 'credentialUsername',
    alternateIdValue: 'alternateIdValue',
    state: 'state',
    reportKind: 'reportKind',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CohortMemberScalarFieldEnum = {
    id: 'id',
    cohortId: 'cohortId',
    facilityId: 'facilityId',
    tierIIReportId: 'tierIIReportId',
    status: 'status',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CommentScalarFieldEnum = {
    id: 'id',
    reportId: 'reportId',
    userId: 'userId',
    isSystemMessage: 'isSystemMessage',
    isStaffOnly: 'isStaffOnly',
    workflowId: 'workflowId',
    activityId: 'activityId',
    submissionId: 'submissionId',
    taskId: 'taskId',
    taskSeriesId: 'taskSeriesId',
    taskDeadline: 'taskDeadline',
    comment: 'comment',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CommunicationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    lepcId: 'lepcId',
    fireDepartmentId: 'fireDepartmentId',
    policeDepartmentId: 'policeDepartmentId',
    leadAgencyId: 'leadAgencyId',
    activityId: 'activityId',
    recipientName: 'recipientName',
    proofDocumentId: 'proofDocumentId',
    communicationType: 'communicationType',
    status: 'status',
    generateCoverLetter: 'generateCoverLetter',
    lobMailId: 'lobMailId',
    jobId: 'jobId',
    sendGridEmailId: 'sendGridEmailId',
    trackingId: 'trackingId',
    emailRecipientAddresses: 'emailRecipientAddresses',
    emailSubject: 'emailSubject',
    emailFrom: 'emailFrom',
    emailReplyTo: 'emailReplyTo',
    templateName: 'templateName',
    emailBody: 'emailBody',
    mailRecipientAddressLine1: 'mailRecipientAddressLine1',
    mailRecipientAddressLine2: 'mailRecipientAddressLine2',
    mailRecipientCity: 'mailRecipientCity',
    mailRecipientState: 'mailRecipientState',
    mailRecipientZip: 'mailRecipientZip',
    completedByUserId: 'completedByUserId',
    completedAt: 'completedAt',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CommunicationDocumentScalarFieldEnum = {
    id: 'id',
    communicationId: 'communicationId',
    documentId: 'documentId',
    sequence: 'sequence',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CommunicationFacilityScalarFieldEnum = {
    id: 'id',
    communicationId: 'communicationId',
    facilityId: 'facilityId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.LobAddressScalarFieldEnum = {
    id: 'id',
    recipient: 'recipient',
    primaryLine: 'primaryLine',
    secondaryLine: 'secondaryLine',
    city: 'city',
    state: 'state',
    zipCode: 'zipCode',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.LobMailScalarFieldEnum = {
    id: 'id',
    lobId: 'lobId',
    type: 'type',
    status: 'status',
    lobUrl: 'lobUrl',
    data: 'data',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SendGridEmailScalarFieldEnum = {
    id: 'id',
    messageId: 'messageId',
    to: 'to',
    from: 'from',
    replyTo: 'replyTo',
    subject: 'subject',
    templateId: 'templateId',
    sendDate: 'sendDate'
};
exports.ComplianceQuarterScalarFieldEnum = {
    quarter: 'quarter',
    cwaIndex: 'cwaIndex',
    caaIndex: 'caaIndex',
    rcraIndex: 'rcraIndex',
    overallIndex: 'overallIndex'
};
exports.AlternateIdCredentialScalarFieldEnum = {
    id: 'id',
    credentialId: 'credentialId',
    alternateIdValue: 'alternateIdValue',
    alternateIdType: 'alternateIdType',
    alternateIdMetadata: 'alternateIdMetadata',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.AlternateIdInfoScalarFieldEnum = {
    id: 'id',
    alternateIdType: 'alternateIdType',
    alternateIdValue: 'alternateIdValue',
    tenantId: 'tenantId',
    description: 'description',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CredentialScalarFieldEnum = {
    id: 'id',
    portalId: 'portalId',
    tenantId: 'tenantId',
    isEncampOwned: 'isEncampOwned',
    name: 'name',
    username: 'username',
    password: 'password',
    email: 'email',
    kind: 'kind',
    securityQuestions: 'securityQuestions',
    verificationStatus: 'verificationStatus',
    lastVerificationSuccessAt: 'lastVerificationSuccessAt',
    lastVerificationCheckAt: 'lastVerificationCheckAt',
    onePasswordId: 'onePasswordId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    usesCombinedInvoicing: 'usesCombinedInvoicing',
    usesRcoCredential: 'usesRcoCredential'
};
exports.CredentialUsageLogScalarFieldEnum = {
    id: 'id',
    credentialId: 'credentialId',
    jobId: 'jobId',
    verificationStatus: 'verificationStatus',
    errorMessage: 'errorMessage',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.OneTimePasswordScalarFieldEnum = {
    id: 'id',
    credentialId: 'credentialId',
    jobId: 'jobId',
    otpCode: 'otpCode',
    emailSentDate: 'emailSentDate',
    conversationId: 'conversationId',
    messageId: 'messageId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.DataLedgerScalarFieldEnum = {
    id: 'id',
    source: 'source',
    target: 'target',
    action: 'action',
    tenantId: 'tenantId',
    tenantName: 'tenantName',
    reportingYear: 'reportingYear',
    user: 'user',
    sessionId: 'sessionId',
    options: 'options',
    performedAt: 'performedAt'
};
exports.DocumentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    title: 'title',
    description: 'description',
    fileExtension: 'fileExtension',
    state: 'state',
    area: 'area',
    documentType: 'documentType',
    storageLink: 'storageLink',
    sizeMegabytes: 'sizeMegabytes',
    lobId: 'lobId',
    originalTitle: 'originalTitle',
    originalDocumentType: 'originalDocumentType',
    isArchived: 'isArchived',
    authoredAt: 'authoredAt',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    extractionStatus: 'extractionStatus',
    lastExtractionAt: 'lastExtractionAt',
    extractionError: 'extractionError'
};
exports.DocumentMetadataScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    type: 'type',
    documentType: 'documentType',
    documentSubtype: 'documentSubtype',
    documentNumber: 'documentNumber',
    relatedDocumentNumber: 'relatedDocumentNumber',
    revisionNumber: 'revisionNumber',
    reportingPeriod: 'reportingPeriod',
    siteName: 'siteName',
    siteAddressLine1: 'siteAddressLine1',
    siteAddressLine2: 'siteAddressLine2',
    siteCity: 'siteCity',
    siteState: 'siteState',
    siteZipCode: 'siteZipCode',
    siteEmail: 'siteEmail',
    mailingName: 'mailingName',
    mailingAddressLine1: 'mailingAddressLine1',
    mailingAddressLine2: 'mailingAddressLine2',
    mailingCity: 'mailingCity',
    mailingState: 'mailingState',
    mailingZipCode: 'mailingZipCode',
    mailingEmail: 'mailingEmail',
    contactName: 'contactName',
    contactEmail: 'contactEmail',
    contactPhone: 'contactPhone',
    contactAddressLine1: 'contactAddressLine1',
    contactAddressLine2: 'contactAddressLine2',
    contactCity: 'contactCity',
    contactState: 'contactState',
    contactZipCode: 'contactZipCode',
    agency: 'agency',
    programArea: 'programArea',
    regulatoryProgram: 'regulatoryProgram',
    regulatoryCitations: 'regulatoryCitations',
    regulatoryAuthority: 'regulatoryAuthority',
    issueDate: 'issueDate',
    expirationDate: 'expirationDate',
    effectiveDate: 'effectiveDate',
    submissionDeadline: 'submissionDeadline',
    dueDate: 'dueDate',
    amount: 'amount',
    currency: 'currency',
    lineItems: 'lineItems',
    relatedDocumentIds: 'relatedDocumentIds',
    supersedes: 'supersedes',
    summary: 'summary',
    keywords: 'keywords',
    embeddingModel: 'embeddingModel',
    embeddingCreatedAt: 'embeddingCreatedAt',
    needsReview: 'needsReview',
    reviewedAt: 'reviewedAt',
    reviewedBy: 'reviewedBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
exports.DocumentTagScalarFieldEnum = {
    id: 'id',
    tagId: 'tagId',
    documentId: 'documentId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.EManifestSiteSyncScalarFieldEnum = {
    id: 'id',
    siteId: 'siteId',
    maxManifestUpdatedDate: 'maxManifestUpdatedDate',
    lastPermissionsErrorAt: 'lastPermissionsErrorAt',
    hasSiteAccess: 'hasSiteAccess',
    syncedAt: 'syncedAt'
};
exports.EmulatedRoleScalarFieldEnum = {
    id: 'id',
    sessionId: 'sessionId',
    userId: 'userId',
    tenantId: 'tenantId',
    roleId: 'roleId',
    permissions: 'permissions',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    expiresAt: 'expiresAt'
};
exports.ErrorClusterScalarFieldEnum = {
    id: 'id',
    workflowType: 'workflowType',
    runId: 'runId',
    jobId: 'jobId',
    groupId: 'groupId',
    tenantId: 'tenantId',
    reportId: 'reportId',
    facilityId: 'facilityId',
    workflowId: 'workflowId',
    activityId: 'activityId',
    tenantName: 'tenantName',
    facilityName: 'facilityName',
    state: 'state',
    activityType: 'activityType',
    activityDescription: 'activityDescription',
    errorMessage: 'errorMessage',
    reportTags: 'reportTags',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CalculatedRegulatoryStatusScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    periodStart: 'periodStart',
    source: 'source',
    federalStatus: 'federalStatus',
    stateStatus: 'stateStatus',
    determinationFactors: 'determinationFactors',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.CalculationOperationScalarFieldEnum = {
    id: 'id',
    reportingFacilityChemicalId: 'reportingFacilityChemicalId',
    operation: 'operation',
    createdAt: 'createdAt'
};
exports.FacilityScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    status: 'status',
    statusReason: 'statusReason',
    businessUnit: 'businessUnit',
    customerFacilityId: 'customerFacilityId',
    dbNumber: 'dbNumber',
    facilityType: 'facilityType',
    naicsCode: 'naicsCode',
    maxNumOccupants: 'maxNumOccupants',
    isUnmanned: 'isUnmanned',
    phone: 'phone',
    phone24Hour: 'phone24Hour',
    streetAddress1: 'streetAddress1',
    streetAddress2: 'streetAddress2',
    city: 'city',
    state: 'state',
    zip: 'zip',
    country: 'country',
    mailingCompanyName: 'mailingCompanyName',
    mailingStreetAddress1: 'mailingStreetAddress1',
    mailingStreetAddress2: 'mailingStreetAddress2',
    mailingCity: 'mailingCity',
    mailingState: 'mailingState',
    mailingZip: 'mailingZip',
    mailingCountry: 'mailingCountry',
    isMailingAddressSameAsFacility: 'isMailingAddressSameAsFacility',
    isMailingAddressEncamp: 'isMailingAddressEncamp',
    county: 'county',
    municipality: 'municipality',
    latitude: 'latitude',
    longitude: 'longitude',
    isAutoGeocoded: 'isAutoGeocoded',
    dateOpened: 'dateOpened',
    dateClosed: 'dateClosed',
    dateInactive: 'dateInactive',
    lastProductMeasuredAt: 'lastProductMeasuredAt',
    streetAddressVerifiedAt: 'streetAddressVerifiedAt',
    isSubjectToEmergencyPlanning: 'isSubjectToEmergencyPlanning',
    isSubjectToEmergencyPlanningInternal: 'isSubjectToEmergencyPlanningInternal',
    isSubjectToChemicalAccidentPrevention: 'isSubjectToChemicalAccidentPrevention',
    isSubjectToToxicsReleaseInventoryReporting: 'isSubjectToToxicsReleaseInventoryReporting',
    collectionMode: 'collectionMode',
    companyName: 'companyName',
    department: 'department',
    isInactive: 'isInactive',
    isClosed: 'isClosed',
    colocationReportingFacilityId: 'colocationReportingFacilityId',
    isNotReporting: 'isNotReporting',
    isNotReportingThroughEncamp: 'isNotReportingThroughEncamp',
    chemicalFeatureFlagOverride: 'chemicalFeatureFlagOverride',
    wasteFeatureFlagOverride: 'wasteFeatureFlagOverride',
    colocationWasteFacilityId: 'colocationWasteFacilityId',
    reportsManually: 'reportsManually',
    useEncampBillingContact: 'useEncampBillingContact',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    fireDepartmentId: 'fireDepartmentId',
    lepcId: 'lepcId',
    fireDepartmentName: 'fireDepartmentName',
    lepcName: 'lepcName',
    embeddingModel: 'embeddingModel',
    embeddingCreatedAt: 'embeddingCreatedAt'
};
exports.FacilityAlternateIdScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    value: 'value',
    hasNoId: 'hasNoId',
    type: 'type',
    expiresAt: 'expiresAt',
    tenantId: 'tenantId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityChemicalScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    chemicalId: 'chemicalId',
    reportingYear: 'reportingYear',
    maxAmount: 'maxAmount',
    maxAmountCode: 'maxAmountCode',
    averageAmount: 'averageAmount',
    averageAmountCode: 'averageAmountCode',
    maxAmountLargestContainer: 'maxAmountLargestContainer',
    daysOnSite: 'daysOnSite',
    hasConfidentialStorageLocations: 'hasConfidentialStorageLocations',
    unit: 'unit',
    isAlwaysReported: 'isAlwaysReported',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityChemicalMeasurementScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    chemicalId: 'chemicalId',
    storageLocationId: 'storageLocationId',
    amount: 'amount',
    unit: 'unit',
    measuredAtUtc: 'measuredAtUtc',
    endDate: 'endDate',
    storageType: 'storageType',
    storageTypeDescription: 'storageTypeDescription',
    pressure: 'pressure',
    temperature: 'temperature',
    otherPressureValue: 'otherPressureValue',
    maxAmountLargestContainer: 'maxAmountLargestContainer',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityChemicalStateFieldScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    chemicalId: 'chemicalId',
    reportingYear: 'reportingYear',
    key: 'key',
    value: 'value',
    type: 'type',
    jurisdiction: 'jurisdiction',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityChemicalStorageLocationScalarFieldEnum = {
    id: 'id',
    facilityChemicalId: 'facilityChemicalId',
    storageLocationId: 'storageLocationId',
    storageType: 'storageType',
    storageTypeDescription: 'storageTypeDescription',
    pressure: 'pressure',
    temperature: 'temperature',
    maxAmount: 'maxAmount',
    unit: 'unit',
    otherPressureValue: 'otherPressureValue',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityContactScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    personId: 'personId',
    reportingRoles: 'reportingRoles',
    isPrimaryContact: 'isPrimaryContact',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityCredentialScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    credentialId: 'credentialId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityDocumentScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    facilityId: 'facilityId',
    currentSubmissionDocument: 'currentSubmissionDocument',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityPaymentScalarFieldEnum = {
    paymentId: 'paymentId',
    facilityId: 'facilityId',
    amount: 'amount',
    transactionFeeAmount: 'transactionFeeAmount'
};
exports.FacilityPilotProgramScalarFieldEnum = {
    id: 'id',
    state: 'state',
    reportingYear: 'reportingYear',
    status: 'status',
    notes: 'notes',
    documentationComplete: 'documentationComplete',
    qaComplete: 'qaComplete',
    createdAt: 'createdAt',
    createdBy: 'createdBy'
};
exports.FacilityPilotProgramLocalScalarFieldEnum = {
    id: 'id',
    state: 'state',
    localJurisdictionName: 'localJurisdictionName',
    reportingYear: 'reportingYear',
    status: 'status',
    notes: 'notes',
    documentationComplete: 'documentationComplete',
    qaComplete: 'qaComplete',
    jurisdictionType: 'jurisdictionType',
    jurisdictionMatchKey: 'jurisdictionMatchKey',
    createdAt: 'createdAt',
    createdBy: 'createdBy'
};
exports.FacilityProductScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    productId: 'productId',
    reportingYear: 'reportingYear',
    maxQuantity: 'maxQuantity',
    averageQuantity: 'averageQuantity',
    daysOnSite: 'daysOnSite',
    hasConfidentialStorageLocations: 'hasConfidentialStorageLocations',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityProductMeasurementScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    productId: 'productId',
    storageLocationId: 'storageLocationId',
    measuredAtUtc: 'measuredAtUtc',
    endDate: 'endDate',
    quantity: 'quantity',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityProductStorageLocationScalarFieldEnum = {
    id: 'id',
    facilityProductId: 'facilityProductId',
    storageLocationId: 'storageLocationId',
    maxQuantity: 'maxQuantity',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityStateFieldScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    key: 'key',
    value: 'value',
    type: 'type',
    jurisdiction: 'jurisdiction',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityTagScalarFieldEnum = {
    id: 'id',
    tagId: 'tagId',
    facilityId: 'facilityId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ProcessedManifestScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    manifestTrackingNumber: 'manifestTrackingNumber',
    eManifestId: 'eManifestId',
    vendorManifestId: 'vendorManifestId',
    hasIssues: 'hasIssues',
    hasIssuesReason: 'hasIssuesReason',
    shippedDate: 'shippedDate',
    epaId: 'epaId',
    destinationFacilityId: 'destinationFacilityId',
    destinationFacilityName: 'destinationFacilityName',
    receivedDate: 'receivedDate',
    vendorSource: 'vendorSource',
    eManifestCreatedDate: 'eManifestCreatedDate',
    eManifestCertifiedDate: 'eManifestCertifiedDate',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ReportingFacilityChemicalScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    chemicalId: 'chemicalId',
    reportingYear: 'reportingYear',
    maxAmount: 'maxAmount',
    maxAmountCode: 'maxAmountCode',
    averageAmount: 'averageAmount',
    averageAmountCode: 'averageAmountCode',
    maxAmountLargestContainer: 'maxAmountLargestContainer',
    daysOnSite: 'daysOnSite',
    hasConfidentialStorageLocations: 'hasConfidentialStorageLocations',
    unit: 'unit',
    isAlwaysReported: 'isAlwaysReported',
    isOverThreshold: 'isOverThreshold',
    thresholdReason: 'thresholdReason',
    manuallyEdited: 'manuallyEdited',
    aggregationErrorMessage: 'aggregationErrorMessage',
    aggregationError: 'aggregationError',
    dailyAmount: 'dailyAmount',
    dailyMaxAmountLargestContainer: 'dailyMaxAmountLargestContainer',
    sequenceNumber: 'sequenceNumber',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ReportingFacilityChemicalOriginScalarFieldEnum = {
    id: 'id',
    reportingFacilityChemicalId: 'reportingFacilityChemicalId',
    facilityChemicalId: 'facilityChemicalId'
};
exports.ReportingFacilityChemicalStorageLocationScalarFieldEnum = {
    id: 'id',
    reportingFacilityChemicalId: 'reportingFacilityChemicalId',
    storageLocationId: 'storageLocationId',
    maxAmount: 'maxAmount',
    unit: 'unit',
    storageType: 'storageType',
    storageTypeDescription: 'storageTypeDescription',
    pressure: 'pressure',
    temperature: 'temperature',
    insideOutside: 'insideOutside',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ReportingFacilityChemicalThresholdResultScalarFieldEnum = {
    id: 'id',
    reportingFacilityChemicalId: 'reportingFacilityChemicalId',
    thresholdResultId: 'thresholdResultId',
    facilityId: 'facilityId',
    contributingAmount: 'contributingAmount',
    componentPercentage: 'componentPercentage',
    ehsFormAdjustment: 'ehsFormAdjustment',
    updatedAt: 'updatedAt',
    createdAt: 'createdAt'
};
exports.ThresholdResultScalarFieldEnum = {
    id: 'id',
    threshold: 'threshold',
    unit: 'unit',
    jurisdiction: 'jurisdiction',
    description: 'description',
    overThreshold: 'overThreshold',
    isSection312: 'isSection312',
    isSection302: 'isSection302',
    type: 'type',
    casNumber: 'casNumber',
    amountCompared: 'amountCompared',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FireDepartmentScalarFieldEnum = {
    id: 'id',
    name: 'name',
    state: 'state',
    city: 'city',
    county: 'county',
    zip: 'zip',
    mailingAddress: 'mailingAddress',
    mailingAddressLine2: 'mailingAddressLine2',
    phone: 'phone',
    phoneExt: 'phoneExt',
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    title: 'title',
    latitude: 'latitude',
    longitude: 'longitude',
    additionalComments: 'additionalComments',
    stateSubmitsToFireDept: 'stateSubmitsToFireDept',
    needsT2sFile: 'needsT2sFile',
    isMailed: 'isMailed',
    isEmailed: 'isEmailed',
    portalId: 'portalId',
    portalName: 'portalName',
    preferUncertified: 'preferUncertified',
    isSubmittedViaPortal: 'isSubmittedViaPortal',
    deactivated: 'deactivated',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.EchoAirFacilityScalarFieldEnum = {
    pgmSysId: 'pgmSysId',
    registryId: 'registryId',
    facilityName: 'facilityName',
    streetAddress: 'streetAddress',
    city: 'city',
    countyName: 'countyName',
    state: 'state',
    zipCode: 'zipCode',
    epaRegion: 'epaRegion',
    sicCodes: 'sicCodes',
    naicsCodes: 'naicsCodes',
    facilityTypeCode: 'facilityTypeCode',
    airPollutantClassCode: 'airPollutantClassCode',
    airPollutantClassDesc: 'airPollutantClassDesc',
    airOperatingStatusCode: 'airOperatingStatusCode',
    airOperatingStatusDesc: 'airOperatingStatusDesc',
    currentHpv: 'currentHpv',
    localControlRegionCode: 'localControlRegionCode',
    localControlRegionName: 'localControlRegionName'
};
exports.EchoAirViolationHistoryScalarFieldEnum = {
    pgmSysId: 'pgmSysId',
    activityId: 'activityId',
    agencyTypeDesc: 'agencyTypeDesc',
    stateCode: 'stateCode',
    airLconCode: 'airLconCode',
    compDeterminationUid: 'compDeterminationUid',
    enfResponsePolicyCode: 'enfResponsePolicyCode',
    programCodes: 'programCodes',
    programDescs: 'programDescs',
    pollutantCodes: 'pollutantCodes',
    pollutantDescs: 'pollutantDescs',
    earliestFrvDetermDate: 'earliestFrvDetermDate',
    hpvDayzeroDate: 'hpvDayzeroDate',
    hpvResolvedDate: 'hpvResolvedDate',
    dscvPathwayDate: 'dscvPathwayDate',
    nftcPathwayDate: 'nftcPathwayDate'
};
exports.CaseEnforcementsScalarFieldEnum = {
    activityId: 'activityId',
    activityName: 'activityName',
    stateCode: 'stateCode',
    regionCode: 'regionCode',
    fiscalYear: 'fiscalYear',
    caseNumber: 'caseNumber',
    caseName: 'caseName',
    activityTypeCode: 'activityTypeCode',
    activityTypeDesc: 'activityTypeDesc',
    activityStatusCode: 'activityStatusCode',
    activityStatusDesc: 'activityStatusDesc',
    activityStatusDate: 'activityStatusDate',
    lead: 'lead',
    caseStatusDate: 'caseStatusDate',
    dojDocketNmbr: 'dojDocketNmbr',
    enfOutcomeCode: 'enfOutcomeCode',
    enfOutcomeDesc: 'enfOutcomeDesc',
    totalPenaltyAssessedAmt: 'totalPenaltyAssessedAmt',
    totalCostRecoveryAmt: 'totalCostRecoveryAmt',
    totalCompActionAmt: 'totalCompActionAmt',
    hqDivision: 'hqDivision',
    branch: 'branch',
    voluntarySelfDisclosureFlag: 'voluntarySelfDisclosureFlag',
    multimediaFlag: 'multimediaFlag',
    enfSummaryText: 'enfSummaryText'
};
exports.CaseProgramsScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    programCode: 'programCode',
    programDesc: 'programDesc'
};
exports.CaseEnforcementConclusionsScalarFieldEnum = {
    enfConclusionId: 'enfConclusionId',
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    enfConclusionNmbr: 'enfConclusionNmbr',
    enfConclusionActionCode: 'enfConclusionActionCode',
    enfConclusionName: 'enfConclusionName',
    settlementLodgedDate: 'settlementLodgedDate',
    settlementEnteredDate: 'settlementEnteredDate',
    settlementFy: 'settlementFy',
    primaryLaw: 'primaryLaw',
    regionCode: 'regionCode',
    activityTypeCode: 'activityTypeCode',
    fedPenaltyAssessedAmt: 'fedPenaltyAssessedAmt',
    stateLocalPenaltyAmt: 'stateLocalPenaltyAmt',
    sepAmt: 'sepAmt',
    complianceActionCost: 'complianceActionCost',
    costRecoveryAwardedAmt: 'costRecoveryAwardedAmt'
};
exports.CaseEnforcementTypeScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    enfTypeCode: 'enfTypeCode',
    enfTypeDesc: 'enfTypeDesc'
};
exports.CasePrioritiesScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    priorityCode: 'priorityCode',
    priorityDesc: 'priorityDesc',
    fiscalYear: 'fiscalYear'
};
exports.CasePollutantsScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    pollutantCode: 'pollutantCode',
    pollutantDesc: 'pollutantDesc',
    chemicalAbstractServiceNmbr: 'chemicalAbstractServiceNmbr'
};
exports.CaseLawSectionsScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    rankOrder: 'rankOrder',
    statuteCode: 'statuteCode',
    lawSectionCode: 'lawSectionCode',
    lawSectionDesc: 'lawSectionDesc',
    echoDesc: 'echoDesc'
};
exports.CaseViolationsScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    violationTypeCode: 'violationTypeCode',
    rankOrder: 'rankOrder',
    violationTypeDesc: 'violationTypeDesc'
};
exports.CaseEnforcementConclusionPollutantsScalarFieldEnum = {
    environmentalImpactId: 'environmentalImpactId',
    enfConclusionId: 'enfConclusionId',
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    compActionId: 'compActionId',
    sepId: 'sepId',
    pollutantCode: 'pollutantCode',
    pollutantName: 'pollutantName',
    averageAnnualValue: 'averageAnnualValue',
    pollutantUnitCode: 'pollutantUnitCode',
    mediaCode: 'mediaCode',
    mediaDesc: 'mediaDesc',
    sepOrCompFlag: 'sepOrCompFlag'
};
exports.EpaInformalEnforcementActionsScalarFieldEnum = {
    pgmSysAcrnm: 'pgmSysAcrnm',
    pgmSysId: 'pgmSysId',
    registryId: 'registryId',
    agency: 'agency',
    activityTypeCode: 'activityTypeCode',
    enfTypeCode: 'enfTypeCode',
    enfTypeDesc: 'enfTypeDesc',
    achievedDate: 'achievedDate',
    enfIdentifier: 'enfIdentifier',
    statute: 'statute'
};
exports.CasePenaltiesScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    fedPenalty: 'fedPenalty',
    stLclPenalty: 'stLclPenalty',
    totalSep: 'totalSep',
    complianceActionCost: 'complianceActionCost',
    federalCostRecoveryAmt: 'federalCostRecoveryAmt',
    stateLocalCostRecoveryAmt: 'stateLocalCostRecoveryAmt',
    penaltyCollectedAmt: 'penaltyCollectedAmt'
};
exports.CaseFacilitiesScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    registryId: 'registryId',
    facilityName: 'facilityName',
    locationAddress: 'locationAddress',
    city: 'city',
    stateCode: 'stateCode',
    zip: 'zip',
    primarySicCode: 'primarySicCode',
    primaryNaicsCode: 'primaryNaicsCode'
};
exports.CaseDefendantsScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    defendantName: 'defendantName',
    namedInComplaintFlag: 'namedInComplaintFlag',
    namedInSettlementFlag: 'namedInSettlementFlag'
};
exports.CaseRelatedActivitiesScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    activityStatusDate: 'activityStatusDate',
    activityTypeCode: 'activityTypeCode',
    activityTypeDesc: 'activityTypeDesc'
};
exports.CaseEnforcementConclusionFacilitiesScalarFieldEnum = {
    enfConclusionId: 'enfConclusionId',
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    icisFacilityInterestId: 'icisFacilityInterestId',
    facilityUin: 'facilityUin',
    facilityName: 'facilityName',
    facilityCity: 'facilityCity',
    facilityState: 'facilityState',
    facilityZip: 'facilityZip'
};
exports.CaseEnforcementConclusionDollarsScalarFieldEnum = {
    enfConclusionId: 'enfConclusionId',
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    stateLocalPenaltyAmt: 'stateLocalPenaltyAmt',
    costRecoveryAmt: 'costRecoveryAmt',
    fedPenalty: 'fedPenalty',
    complianceActionCost: 'complianceActionCost',
    sepCost: 'sepCost',
    penaltyCollectedAmt: 'penaltyCollectedAmt'
};
exports.IcisFecEpaInspectionsScalarFieldEnum = {
    activityId: 'activityId',
    registryId: 'registryId',
    pgmSysAcrnm: 'pgmSysAcrnm',
    pgmSysId: 'pgmSysId',
    facilityName: 'facilityName',
    epaRegionCode: 'epaRegionCode',
    activityTypeCode: 'activityTypeCode',
    activityTypeDesc: 'activityTypeDesc',
    compMonitorUid: 'compMonitorUid',
    compMonitorTypes: 'compMonitorTypes',
    statuteCode: 'statuteCode',
    lawSectionCode: 'lawSectionCode',
    actualBeginDate: 'actualBeginDate',
    actualEndDate: 'actualEndDate',
    agency: 'agency',
    compMonitorAgencyTypes: 'compMonitorAgencyTypes'
};
exports.CaseRegionalDocketsScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    regionalDocketNmbr: 'regionalDocketNmbr'
};
exports.CaseReliefSoughtScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    reliefCode: 'reliefCode',
    reliefDesc: 'reliefDesc'
};
exports.CaseEnforcementConclusionSepScalarFieldEnum = {
    enfConclusionId: 'enfConclusionId',
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    sepCategoryCode: 'sepCategoryCode',
    sepCategoryDesc: 'sepCategoryDesc',
    sepId: 'sepId',
    sepText: 'sepText',
    sepAmt: 'sepAmt'
};
exports.CaseEnforcementConclusionComplyingActionsScalarFieldEnum = {
    compActionId: 'compActionId',
    enfConclusionId: 'enfConclusionId',
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    compActionDescription: 'compActionDescription',
    compActionTypeCode: 'compActionTypeCode',
    compActionTypeDesc: 'compActionTypeDesc',
    compActionCategoryTypeDesc: 'compActionCategoryTypeDesc'
};
exports.CaseMilestonesScalarFieldEnum = {
    activityId: 'activityId',
    caseNumber: 'caseNumber',
    subActivityTypeCode: 'subActivityTypeCode',
    subActivityTypeDesc: 'subActivityTypeDesc',
    actualDate: 'actualDate'
};
exports.EchoExporterScalarFieldEnum = {
    registryId: 'registryId',
    facName: 'facName',
    facStreet: 'facStreet',
    facCity: 'facCity',
    facState: 'facState',
    facZip: 'facZip',
    facCounty: 'facCounty',
    facFipsCode: 'facFipsCode',
    facEpaRegion: 'facEpaRegion',
    facIndianCntryFlg: 'facIndianCntryFlg',
    facFederalFlg: 'facFederalFlg',
    facUsMexBorderFlg: 'facUsMexBorderFlg',
    facChesapeakeBayFlg: 'facChesapeakeBayFlg',
    facNaaFlag: 'facNaaFlag',
    facLat: 'facLat',
    facLong: 'facLong',
    facMapIcon: 'facMapIcon',
    facCollectionMethod: 'facCollectionMethod',
    facReferencePoint: 'facReferencePoint',
    facAccuracyMeters: 'facAccuracyMeters',
    facDerivedTribes: 'facDerivedTribes',
    facDerivedHuc: 'facDerivedHuc',
    facDerivedWbd: 'facDerivedWbd',
    facDerivedStctyFips: 'facDerivedStctyFips',
    facDerivedZip: 'facDerivedZip',
    facDerivedCd113: 'facDerivedCd113',
    facDerivedCb2010: 'facDerivedCb2010',
    facPercentMinority: 'facPercentMinority',
    facPopDen: 'facPopDen',
    facMajorFlag: 'facMajorFlag',
    facActiveFlag: 'facActiveFlag',
    facMyrtkUniverse: 'facMyrtkUniverse',
    facInspectionCount: 'facInspectionCount',
    facDateLastInspection: 'facDateLastInspection',
    facDaysLastInspection: 'facDaysLastInspection',
    facInformalCount: 'facInformalCount',
    facDateLastInformalAction: 'facDateLastInformalAction',
    facFormalActionCount: 'facFormalActionCount',
    facDateLastFormalAction: 'facDateLastFormalAction',
    facTotalPenalties: 'facTotalPenalties',
    facPenaltyCount: 'facPenaltyCount',
    facDateLastPenalty: 'facDateLastPenalty',
    facLastPenaltyAmt: 'facLastPenaltyAmt',
    facQtrsWithNc: 'facQtrsWithNc',
    facProgramsWithSnc: 'facProgramsWithSnc',
    facComplianceStatus: 'facComplianceStatus',
    facSncFlg: 'facSncFlg',
    fac3yrComplianceHistory: 'fac3yrComplianceHistory',
    airFlag: 'airFlag',
    npdesFlag: 'npdesFlag',
    sdwisFlag: 'sdwisFlag',
    rcraFlag: 'rcraFlag',
    triFlag: 'triFlag',
    ghgFlag: 'ghgFlag',
    airIds: 'airIds',
    caaPermitTypes: 'caaPermitTypes',
    caaNaics: 'caaNaics',
    caaSics: 'caaSics',
    caaEvaluationCount: 'caaEvaluationCount',
    caaDaysLastEvaluation: 'caaDaysLastEvaluation',
    caaInformalCount: 'caaInformalCount',
    caaFormalActionCount: 'caaFormalActionCount',
    caaDateLastFormalAction: 'caaDateLastFormalAction',
    caaPenalties: 'caaPenalties',
    caaLastPenaltyDate: 'caaLastPenaltyDate',
    caaLastPenaltyAmt: 'caaLastPenaltyAmt',
    caaQtrsWithNc: 'caaQtrsWithNc',
    caaComplianceStatus: 'caaComplianceStatus',
    caaHpvFlag: 'caaHpvFlag',
    caa3yrComplQtrsHistory: 'caa3yrComplQtrsHistory',
    npdesIds: 'npdesIds',
    cwaPermitTypes: 'cwaPermitTypes',
    cwaComplianceTracking: 'cwaComplianceTracking',
    cwaNaics: 'cwaNaics',
    cwaSics: 'cwaSics',
    cwaInspectionCount: 'cwaInspectionCount',
    cwaDaysLastInspection: 'cwaDaysLastInspection',
    cwaInformalCount: 'cwaInformalCount',
    cwaFormalActionCount: 'cwaFormalActionCount',
    cwaDateLastFormalAction: 'cwaDateLastFormalAction',
    cwaPenalties: 'cwaPenalties',
    cwaLastPenaltyDate: 'cwaLastPenaltyDate',
    cwaLastPenaltyAmt: 'cwaLastPenaltyAmt',
    cwaQtrsWithNc: 'cwaQtrsWithNc',
    cwaComplianceStatus: 'cwaComplianceStatus',
    cwaSncFlag: 'cwaSncFlag',
    cwa13qtrsComplHistory: 'cwa13qtrsComplHistory',
    cwa13qtrsEfflntExceedances: 'cwa13qtrsEfflntExceedances',
    cwa3yrQncrCodes: 'cwa3yrQncrCodes',
    rcraIds: 'rcraIds',
    rcraPermitTypes: 'rcraPermitTypes',
    rcraNaics: 'rcraNaics',
    rcraInspectionCount: 'rcraInspectionCount',
    rcraDaysLastEvaluation: 'rcraDaysLastEvaluation',
    rcraInformalCount: 'rcraInformalCount',
    rcraFormalActionCount: 'rcraFormalActionCount',
    rcraDateLastFormalAction: 'rcraDateLastFormalAction',
    rcraPenalties: 'rcraPenalties',
    rcraLastPenaltyDate: 'rcraLastPenaltyDate',
    rcraLastPenaltyAmt: 'rcraLastPenaltyAmt',
    rcraQtrsWithNc: 'rcraQtrsWithNc',
    rcraComplianceStatus: 'rcraComplianceStatus',
    rcraSncFlag: 'rcraSncFlag',
    rcra3yrComplQtrsHistory: 'rcra3yrComplQtrsHistory',
    sdwaIds: 'sdwaIds',
    sdwaSystemTypes: 'sdwaSystemTypes',
    sdwaInformalCount: 'sdwaInformalCount',
    sdwaFormalActionCount: 'sdwaFormalActionCount',
    sdwaComplianceStatus: 'sdwaComplianceStatus',
    sdwaSncFlag: 'sdwaSncFlag',
    triIds: 'triIds',
    triReleasesTransfers: 'triReleasesTransfers',
    triOnSiteReleases: 'triOnSiteReleases',
    triOffSiteTransfers: 'triOffSiteTransfers',
    triReporterInPast: 'triReporterInPast',
    fecCaseIds: 'fecCaseIds',
    fecNumberOfCases: 'fecNumberOfCases',
    fecLastCaseDate: 'fecLastCaseDate',
    fecTotalPenalties: 'fecTotalPenalties',
    ghgIds: 'ghgIds',
    ghgCo2Releases: 'ghgCo2Releases',
    dfrUrl: 'dfrUrl',
    facSicCodes: 'facSicCodes',
    facNaicsCodes: 'facNaicsCodes',
    facDateLastInspectionEpa: 'facDateLastInspectionEpa',
    facDateLastInspectionState: 'facDateLastInspectionState',
    facDateLastFormalActEpa: 'facDateLastFormalActEpa',
    facDateLastFormalActSt: 'facDateLastFormalActSt',
    facDateLastInformalActEpa: 'facDateLastInformalActEpa',
    facDateLastInformalActSt: 'facDateLastInformalActSt',
    facFederalAgency: 'facFederalAgency',
    triReporter: 'triReporter',
    facImpWaterFlg: 'facImpWaterFlg',
    ejscreenFlagUs: 'ejscreenFlagUs'
};
exports.EchoFacilityMatchCandidateScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    registryId: 'registryId',
    matchScore: 'matchScore',
    jobId: 'jobId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.NpdesCsViolationScalarFieldEnum = {
    id: 'id',
    npdesId: 'npdesId',
    npdesViolationId: 'npdesViolationId',
    violationTypeCode: 'violationTypeCode',
    compScheduleEventId: 'compScheduleEventId',
    compScheduleNmbr: 'compScheduleNmbr',
    violationCode: 'violationCode',
    violationDesc: 'violationDesc',
    scheduleEventCode: 'scheduleEventCode',
    scheduleEventDesc: 'scheduleEventDesc',
    scheduleDate: 'scheduleDate',
    actualDate: 'actualDate',
    rncDetectionCode: 'rncDetectionCode',
    rncDetectionDesc: 'rncDetectionDesc',
    rncDetectionDate: 'rncDetectionDate',
    rncResolutionCode: 'rncResolutionCode',
    rncResolutionDesc: 'rncResolutionDesc',
    rncResolutionDate: 'rncResolutionDate',
    reportReceivedDate: 'reportReceivedDate'
};
exports.NpdesEffViolationScalarFieldEnum = {
    npdesId: 'npdesId',
    versionNmbr: 'versionNmbr',
    activityId: 'activityId',
    npdesViolationId: 'npdesViolationId',
    monitoringPeriodEndDate: 'monitoringPeriodEndDate'
};
exports.NpdesPsViolationScalarFieldEnum = {
    id: 'id',
    npdesId: 'npdesId',
    npdesViolationId: 'npdesViolationId',
    permScheduleEventId: 'permScheduleEventId',
    violationTypeCode: 'violationTypeCode',
    violationCode: 'violationCode',
    violationDesc: 'violationDesc',
    scheduleEventCode: 'scheduleEventCode',
    scheduleEventDesc: 'scheduleEventDesc',
    scheduleDate: 'scheduleDate',
    rncDetectionCode: 'rncDetectionCode',
    rncDetectionDesc: 'rncDetectionDesc',
    rncDetectionDate: 'rncDetectionDate',
    rncResolutionCode: 'rncResolutionCode',
    rncResolutionDesc: 'rncResolutionDesc',
    rncResolutionDate: 'rncResolutionDate',
    actualDate: 'actualDate',
    reportReceivedDate: 'reportReceivedDate'
};
exports.NpdesSeViolationScalarFieldEnum = {
    id: 'id',
    npdesId: 'npdesId',
    npdesViolationId: 'npdesViolationId',
    violationTypeCode: 'violationTypeCode',
    violationCode: 'violationCode',
    violationDesc: 'violationDesc',
    singleEventViolationDate: 'singleEventViolationDate',
    singleEventEndDate: 'singleEventEndDate',
    singleEventViolationComment: 'singleEventViolationComment',
    singleEventAgencyTypeCode: 'singleEventAgencyTypeCode',
    rncDetectionCode: 'rncDetectionCode',
    rncDetectionDesc: 'rncDetectionDesc',
    rncDetectionDate: 'rncDetectionDate',
    rncResolutionCode: 'rncResolutionCode',
    rncResolutionDesc: 'rncResolutionDesc',
    rncResolutionDate: 'rncResolutionDate'
};
exports.NpdesFacilityScalarFieldEnum = {
    icisFacilityInterestId: 'icisFacilityInterestId',
    npdesId: 'npdesId',
    facilityUin: 'facilityUin',
    facilityTypeCode: 'facilityTypeCode',
    facilityName: 'facilityName',
    locationAddress: 'locationAddress',
    supplementalAddressText: 'supplementalAddressText',
    city: 'city',
    countyCode: 'countyCode',
    stateCode: 'stateCode',
    zip: 'zip',
    geocodeLatitude: 'geocodeLatitude',
    geocodeLongitude: 'geocodeLongitude',
    impairedWaters: 'impairedWaters'
};
exports.NpdesPermitScalarFieldEnum = {
    activityId: 'activityId',
    externalPermitNmbr: 'externalPermitNmbr',
    versionNmbr: 'versionNmbr',
    facilityTypeIndicator: 'facilityTypeIndicator',
    permitTypeCode: 'permitTypeCode',
    majorMinorStatusFlag: 'majorMinorStatusFlag',
    permitStatusCode: 'permitStatusCode',
    totalDesignFlowNmbr: 'totalDesignFlowNmbr',
    actualAverageFlowNmbr: 'actualAverageFlowNmbr',
    stateWaterBody: 'stateWaterBody',
    stateWaterBodyName: 'stateWaterBodyName',
    permitName: 'permitName',
    agencyTypeCode: 'agencyTypeCode',
    originalIssueDate: 'originalIssueDate',
    issueDate: 'issueDate',
    issuingAgency: 'issuingAgency',
    effectiveDate: 'effectiveDate',
    expirationDate: 'expirationDate',
    retirementDate: 'retirementDate',
    terminationDate: 'terminationDate',
    permitCompStatusFlag: 'permitCompStatusFlag',
    dmrNonReceiptFlag: 'dmrNonReceiptFlag',
    rncTrackingFlag: 'rncTrackingFlag',
    masterExternalPermitNmbr: 'masterExternalPermitNmbr',
    tmdlInterfaceFlag: 'tmdlInterfaceFlag',
    edmrAuthorizationFlag: 'edmrAuthorizationFlag',
    pretreatmentIndicatorCode: 'pretreatmentIndicatorCode',
    radWbdHuc12s: 'radWbdHuc12s'
};
exports.NpdesQncrHistoryScalarFieldEnum = {
    npdesId: 'npdesId',
    yearqtr: 'yearqtr',
    hlrnc: 'hlrnc',
    nume90q: 'nume90q',
    numcvdt: 'numcvdt',
    numsvcd: 'numsvcd',
    numpsch: 'numpsch',
    numd8090q: 'numd8090q'
};
exports.EchoRcraFacilityScalarFieldEnum = {
    idNumber: 'idNumber',
    facilityName: 'facilityName',
    activityLocation: 'activityLocation',
    fullEnforcement: 'fullEnforcement',
    hreportUniverseRecord: 'hreportUniverseRecord',
    streetAddress: 'streetAddress',
    cityName: 'cityName',
    stateCode: 'stateCode',
    zipCode: 'zipCode',
    latitude83: 'latitude83',
    longitude83: 'longitude83',
    fedWasteGenerator: 'fedWasteGenerator',
    transporter: 'transporter',
    activeSite: 'activeSite',
    operatingTsdf: 'operatingTsdf'
};
exports.EchoRcraVioSncHistoryScalarFieldEnum = {
    idNumber: 'idNumber',
    activityLocation: 'activityLocation',
    yrmonth: 'yrmonth',
    vioFlag: 'vioFlag',
    sncFlag: 'sncFlag'
};
exports.EchoRcraViolationScalarFieldEnum = {
    id: 'id',
    idNumber: 'idNumber',
    activityLocation: 'activityLocation',
    violationType: 'violationType',
    violationTypeDesc: 'violationTypeDesc',
    violDeterminedByAgency: 'violDeterminedByAgency',
    dateViolationDetermined: 'dateViolationDetermined',
    actualRtcDate: 'actualRtcDate',
    scheduledComplianceDate: 'scheduledComplianceDate'
};
exports.NationalContactFileScalarFieldEnum = {
    id: 'id',
    registryId: 'registryId',
    pgmSysAcrnm: 'pgmSysAcrnm',
    pgmSysId: 'pgmSysId',
    interestType: 'interestType',
    affiliationType: 'affiliationType',
    startDate: 'startDate',
    endDate: 'endDate',
    fullName: 'fullName',
    title: 'title',
    phoneNumber: 'phoneNumber',
    alternatePhone: 'alternatePhone',
    faxNumber: 'faxNumber',
    emailAddress: 'emailAddress',
    mailingAddress: 'mailingAddress',
    supplementalAddress: 'supplementalAddress',
    cityName: 'cityName',
    stateCode: 'stateCode',
    stateName: 'stateName',
    postalCode: 'postalCode',
    countryName: 'countryName'
};
exports.InsightsCohortScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    nameSearches: 'nameSearches',
    domainSearches: 'domainSearches'
};
exports.HdHandlerScalarFieldEnum = {
    handlerId: 'handlerId',
    activityLocation: 'activityLocation',
    sourceType: 'sourceType',
    seqNumber: 'seqNumber',
    receiveDate: 'receiveDate',
    handlerName: 'handlerName',
    nonNotifier: 'nonNotifier',
    acknowledgeDate: 'acknowledgeDate',
    acknowledgeFlag: 'acknowledgeFlag',
    accessibility: 'accessibility',
    locationStreetNo: 'locationStreetNo',
    locationStreet1: 'locationStreet1',
    locationStreet2: 'locationStreet2',
    locationCity: 'locationCity',
    locationState: 'locationState',
    locationZip: 'locationZip',
    locationCountry: 'locationCountry',
    countyCode: 'countyCode',
    locationLatitude: 'locationLatitude',
    locationLongitude: 'locationLongitude',
    locationGisPrimary: 'locationGisPrimary',
    locationGisOrigin: 'locationGisOrigin',
    stateDistrictOwner: 'stateDistrictOwner',
    stateDistrict: 'stateDistrict',
    landType: 'landType',
    mailStreetNo: 'mailStreetNo',
    mailStreet1: 'mailStreet1',
    mailStreet2: 'mailStreet2',
    mailCity: 'mailCity',
    mailState: 'mailState',
    mailZip: 'mailZip',
    mailCountry: 'mailCountry',
    contactFirstName: 'contactFirstName',
    contactMiddleInitial: 'contactMiddleInitial',
    contactLastName: 'contactLastName',
    contactStreetNo: 'contactStreetNo',
    contactStreet1: 'contactStreet1',
    contactStreet2: 'contactStreet2',
    contactCity: 'contactCity',
    contactState: 'contactState',
    contactZip: 'contactZip',
    contactCountry: 'contactCountry',
    contactPhone: 'contactPhone',
    contactPhoneExt: 'contactPhoneExt',
    contactFax: 'contactFax',
    contactEmailAddress: 'contactEmailAddress',
    contactTitle: 'contactTitle',
    contactLanguage: 'contactLanguage',
    fedWasteGeneratorOwner: 'fedWasteGeneratorOwner',
    fedWasteGenerator: 'fedWasteGenerator',
    stateWasteGeneratorOwner: 'stateWasteGeneratorOwner',
    stateWasteGenerator: 'stateWasteGenerator',
    shortTermGenerator: 'shortTermGenerator',
    importerActivity: 'importerActivity',
    mixedWasteGenerator: 'mixedWasteGenerator',
    transporter: 'transporter',
    transferFacility: 'transferFacility',
    tsdActivity: 'tsdActivity',
    recyclerActivity: 'recyclerActivity',
    onsiteBurnerExemption: 'onsiteBurnerExemption',
    furnaceExemption: 'furnaceExemption',
    undergroundInjectionActivity: 'undergroundInjectionActivity',
    offSiteReceipt: 'offSiteReceipt',
    universalWasteDestFacility: 'universalWasteDestFacility',
    usedOilTransporter: 'usedOilTransporter',
    usedOilTransferFacility: 'usedOilTransferFacility',
    usedOilProcessor: 'usedOilProcessor',
    usedOilRefiner: 'usedOilRefiner',
    usedOilBurner: 'usedOilBurner',
    usedOilMarketBurner: 'usedOilMarketBurner',
    usedOilSpecMarketer: 'usedOilSpecMarketer',
    subpartKCollege: 'subpartKCollege',
    subpartKHospital: 'subpartKHospital',
    subpartKNonprofit: 'subpartKNonprofit',
    subpartKWithdrawal: 'subpartKWithdrawal',
    includeInNationalReport: 'includeInNationalReport',
    reportCycle: 'reportCycle',
    brExempt: 'brExempt',
    cdxTransactionId: 'cdxTransactionId',
    userId: 'userId',
    lastChange: 'lastChange',
    notes: 'notes',
    publicNotes: 'publicNotes',
    shortTermGeneratorNotes: 'shortTermGeneratorNotes',
    lqhuw: 'lqhuw',
    dataOrigin: 'dataOrigin',
    createdByUserId: 'createdByUserId',
    createdDate: 'createdDate',
    recognizedTraderImporter: 'recognizedTraderImporter',
    recognizedTraderExporter: 'recognizedTraderExporter',
    slabImporter: 'slabImporter',
    slabExporter: 'slabExporter',
    currentRecord: 'currentRecord',
    recyclerActivityNonstorage: 'recyclerActivityNonstorage',
    manifestBroker: 'manifestBroker',
    subpartPHealthcare: 'subpartPHealthcare',
    subpartPReverseDistributor: 'subpartPReverseDistributor',
    subpartPWithdrawal: 'subpartPWithdrawal',
    ownerName: 'ownerName',
    operatorName: 'operatorName'
};
exports.HdOwnerOperatorScalarFieldEnum = {
    handlerId: 'handlerId',
    activityLocation: 'activityLocation',
    sourceType: 'sourceType',
    seqNumber: 'seqNumber',
    ownerOperatorSeq: 'ownerOperatorSeq',
    ownerOperatorIndicator: 'ownerOperatorIndicator',
    ownerOperatorType: 'ownerOperatorType',
    ownerOperatorName: 'ownerOperatorName',
    dateBecameCurrent: 'dateBecameCurrent',
    dateEndedCurrent: 'dateEndedCurrent',
    streetNo: 'streetNo',
    street1: 'street1',
    street2: 'street2',
    city: 'city',
    state: 'state',
    zip: 'zip',
    country: 'country',
    phone: 'phone',
    phoneExt: 'phoneExt',
    fax: 'fax',
    email: 'email',
    publicNotes: 'publicNotes'
};
exports.WasteLineScalarFieldEnum = {
    manifestId: 'manifestId',
    manifestTrackingNumber: 'manifestTrackingNumber',
    wasteLineNumber: 'wasteLineNumber',
    dotHazardous: 'dotHazardous',
    dotIdNumberDescription: 'dotIdNumberDescription',
    dotPrintedInformation: 'dotPrintedInformation',
    nonHazWasteDescription: 'nonHazWasteDescription',
    containerNumber: 'containerNumber',
    containerTypeCode: 'containerTypeCode',
    containerTypeDescription: 'containerTypeDescription',
    disposalManagementCode: 'disposalManagementCode',
    quantity: 'quantity',
    qtyUnitOfMeasureCode: 'qtyUnitOfMeasureCode',
    qtyUnitOfMeasureDesc: 'qtyUnitOfMeasureDesc',
    quantityTons: 'quantityTons',
    quantityAcuteTons: 'quantityAcuteTons',
    quantityNonAcuteTons: 'quantityNonAcuteTons',
    quantityKg: 'quantityKg',
    quantityAcuteKg: 'quantityAcuteKg',
    quantityNonAcuteKg: 'quantityNonAcuteKg',
    managementMethodCode: 'managementMethodCode',
    managementMethodDescription: 'managementMethodDescription',
    finalManagementMethodCode: 'finalManagementMethodCode',
    finalManagementMethodDescription: 'finalManagementMethodDescription',
    wasteResidue: 'wasteResidue',
    quantityDiscrepancy: 'quantityDiscrepancy',
    wasteTypeDiscrepancy: 'wasteTypeDiscrepancy',
    brDensity: 'brDensity',
    brDensityUomCode: 'brDensityUomCode',
    brDensityUomDescription: 'brDensityUomDescription',
    brFormCode: 'brFormCode',
    brFormCodeDescription: 'brFormCodeDescription',
    brSourceCode: 'brSourceCode',
    brSourceCodeDescription: 'brSourceCodeDescription',
    brWasteMinCode: 'brWasteMinCode',
    brWasteMinDescription: 'brWasteMinDescription',
    consentNumber: 'consentNumber',
    epaWaste: 'epaWaste',
    quantityHazKg: 'quantityHazKg',
    quantityHazTons: 'quantityHazTons',
    quantityNonHazKg: 'quantityNonHazKg',
    quantityNonHazTons: 'quantityNonHazTons',
    federalWasteCodes: 'federalWasteCodes',
    stateWasteCodes: 'stateWasteCodes',
    eManifestProfileNumber: 'eManifestProfileNumber',
    eManifestComments: 'eManifestComments',
    eManifestWillNotReport: 'eManifestWillNotReport',
    vendorProfileNumber: 'vendorProfileNumber',
    vendorProfileDescription: 'vendorProfileDescription',
    vendorComments: 'vendorComments',
    vendorClassification: 'vendorClassification',
    vendorWillNotReport: 'vendorWillNotReport',
    vendorTSDFApprovalCode: 'vendorTSDFApprovalCode',
    vendorDisposalMethod: 'vendorDisposalMethod',
    vendorWasteTypeDescription: 'vendorWasteTypeDescription',
    vendorWasteTypeCategory: 'vendorWasteTypeCategory',
    vendorBillUnit: 'vendorBillUnit',
    vendorBillQuantity: 'vendorBillQuantity',
    vendorUnitPrice: 'vendorUnitPrice',
    vendorSequenceID: 'vendorSequenceID',
    vendorDisposalDescription: 'vendorDisposalDescription',
    vendorFederal: 'vendorFederal',
    vendorStateHazLbs: 'vendorStateHazLbs',
    vendorUWLbs: 'vendorUWLbs',
    vendorServiceYearMonth: 'vendorServiceYearMonth',
    wasteStreamHashKey: 'wasteStreamHashKey',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteLineTagScalarFieldEnum = {
    id: 'id',
    tagId: 'tagId',
    manifestId: 'manifestId',
    wasteLineNumber: 'wasteLineNumber',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteManifestScalarFieldEnum = {
    id: 'id',
    manifestTrackingNumber: 'manifestTrackingNumber',
    manifestSource: 'manifestSource',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    updatedDate: 'updatedDate',
    shippedDate: 'shippedDate',
    receivedDate: 'receivedDate',
    status: 'status',
    submissionType: 'submissionType',
    originType: 'originType',
    generatorId: 'generatorId',
    generatorName: 'generatorName',
    generatorMailStreetNo: 'generatorMailStreetNo',
    generatorMailStreet1: 'generatorMailStreet1',
    generatorMailStreet2: 'generatorMailStreet2',
    generatorMailCity: 'generatorMailCity',
    generatorMailZip: 'generatorMailZip',
    generatorMailState: 'generatorMailState',
    generatorLocationStreetNo: 'generatorLocationStreetNo',
    generatorLocationStreet1: 'generatorLocationStreet1',
    generatorLocationStreet2: 'generatorLocationStreet2',
    generatorLocationCity: 'generatorLocationCity',
    generatorLocationZip: 'generatorLocationZip',
    generatorLocationState: 'generatorLocationState',
    generatorContactCompanyName: 'generatorContactCompanyName',
    desFacilityId: 'desFacilityId',
    desFacilityName: 'desFacilityName',
    desFacMailStreetNo: 'desFacMailStreetNo',
    desFacMailStreet1: 'desFacMailStreet1',
    desFacMailStreet2: 'desFacMailStreet2',
    desFacMailCity: 'desFacMailCity',
    desFacMailZip: 'desFacMailZip',
    desFacMailState: 'desFacMailState',
    desFacLocationStreetNo: 'desFacLocationStreetNo',
    desFacLocationStreet1: 'desFacLocationStreet1',
    desFacLocationStreet2: 'desFacLocationStreet2',
    desFacLocationCity: 'desFacLocationCity',
    desFacLocationZip: 'desFacLocationZip',
    desFacLocationState: 'desFacLocationState',
    desFacContactCompanyName: 'desFacContactCompanyName',
    manifestResidue: 'manifestResidue',
    rejection: 'rejection',
    totalQuantityAcuteKg: 'totalQuantityAcuteKg',
    totalQuantityAcuteTons: 'totalQuantityAcuteTons',
    totalQuantityHazKg: 'totalQuantityHazKg',
    totalQuantityHazTons: 'totalQuantityHazTons',
    totalQuantityNonAcuteKg: 'totalQuantityNonAcuteKg',
    totalQuantityNonAcuteTons: 'totalQuantityNonAcuteTons',
    totalQuantityNonHazKg: 'totalQuantityNonHazKg',
    totalQuantityNonHazTons: 'totalQuantityNonHazTons',
    totalQuantityKg: 'totalQuantityKg',
    totalQuantityTons: 'totalQuantityTons',
    brokerId: 'brokerId',
    ingestSource: 'ingestSource',
    manuallyEdited: 'manuallyEdited',
    vendorSource: 'vendorSource',
    vendorSiteId: 'vendorSiteId',
    vendorCompanyID: 'vendorCompanyID',
    vendorProfitCtrID: 'vendorProfitCtrID',
    vendorCustomerID: 'vendorCustomerID',
    vendorCustomerName: 'vendorCustomerName',
    vendorWorkOrderId: 'vendorWorkOrderId',
    vendorGeneratorID: 'vendorGeneratorID',
    vendorGeneratorSiteCode: 'vendorGeneratorSiteCode',
    vendorGeneratorSiteType: 'vendorGeneratorSiteType',
    vendorGeneratorSublocationCode: 'vendorGeneratorSublocationCode',
    vendorPurchaseOrder: 'vendorPurchaseOrder',
    vendorInvoiceCode: 'vendorInvoiceCode',
    vendorInvoiceDate: 'vendorInvoiceDate',
    vendorResourceType: 'vendorResourceType',
    vendorTSDFCode: 'vendorTSDFCode',
    vendorBillTotal: 'vendorBillTotal',
    vendorDisposalDescription: 'vendorDisposalDescription',
    vendorFederal: 'vendorFederal',
    vendorStateHazLbs: 'vendorStateHazLbs',
    vendorUWLbs: 'vendorUWLbs',
    vendorServiceYearMonth: 'vendorServiceYearMonth',
    originalManifestTrackingNumber: 'originalManifestTrackingNumber',
    originalShippedDate: 'originalShippedDate',
    originalVendorSource: 'originalVendorSource',
    originalDesFacilityName: 'originalDesFacilityName',
    eManifestCreatedDate: 'eManifestCreatedDate',
    eManifestCertifiedDate: 'eManifestCertifiedDate',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    isDemo: 'isDemo'
};
exports.WasteTransporterScalarFieldEnum = {
    manifestId: 'manifestId',
    manifestTrackingNumber: 'manifestTrackingNumber',
    transporterLineNumber: 'transporterLineNumber',
    transporterId: 'transporterId',
    transporterName: 'transporterName',
    daysInPossession: 'daysInPossession',
    vendorAddressLine1: 'vendorAddressLine1',
    vendorAddressLine2: 'vendorAddressLine2',
    vendorCity: 'vendorCity',
    vendorState: 'vendorState',
    vendorZip: 'vendorZip',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityModelIssueScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    reportId: 'reportId',
    reportingYear: 'reportingYear',
    schemaPath: 'schemaPath',
    modelIssueId: 'modelIssueId',
    ignoreForReport: 'ignoreForReport'
};
exports.FacilityModelIssueCountScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    reportId: 'reportId',
    reportingYear: 'reportingYear',
    count: 'count',
    countForReport: 'countForReport',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
exports.ModelIssueScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    modelName: 'modelName',
    modelId: 'modelId',
    message: 'message',
    propertyKey: 'propertyKey',
    dataName: 'dataName',
    validatedAt: 'validatedAt',
    isRevalidating: 'isRevalidating'
};
exports.JobLogScalarFieldEnum = {
    id: 'id',
    jobId: 'jobId',
    status: 'status',
    taskArn: 'taskArn',
    taskDefinitionArn: 'taskDefinitionArn',
    errorMessage: 'errorMessage',
    stackTrace: 'stackTrace',
    cloudWatchLogStream: 'cloudWatchLogStream',
    screenshotKey: 'screenshotKey',
    htmlKey: 'htmlKey',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
exports.JobStepsDoneScalarFieldEnum = {
    id: 'id',
    jobId: 'jobId',
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
exports.JobScalarFieldEnum = {
    id: 'id',
    task: 'task',
    status: 'status',
    runsOn: 'runsOn',
    parameters: 'parameters',
    taskArn: 'taskArn',
    taskDefinitionArn: 'taskDefinitionArn',
    action: 'action',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    reportId: 'reportId',
    documentId: 'documentId',
    initiatedByUserId: 'initiatedByUserId',
    requestId: 'requestId',
    encampRequestId: 'encampRequestId',
    credentialUsername: 'credentialUsername',
    credentialId: 'credentialId',
    stateOrTerritory: 'stateOrTerritory',
    forceClassicSubmissionStrategy: 'forceClassicSubmissionStrategy',
    evidenceOfCompletionActions: 'evidenceOfCompletionActions',
    stepError: 'stepError',
    reportingYear: 'reportingYear',
    extractionKey: 'extractionKey',
    output: 'output',
    staffReportKey: 'staffReportKey',
    totalIssues: 'totalIssues',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    promotedAt: 'promotedAt',
    promotedBy: 'promotedBy',
    activityId: 'activityId'
};
exports.JobManagerConfigScalarFieldEnum = {
    id: 'id',
    task: 'task',
    maxConcurrency: 'maxConcurrency',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.LeadAgencyScalarFieldEnum = {
    id: 'id',
    address: 'address',
    name: 'name',
    additionalComments: 'additionalComments',
    attn: 'attn',
    city: 'city',
    consolidated: 'consolidated',
    phone: 'phone',
    state: 'state',
    zip: 'zip',
    email: 'email',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.LepcScalarFieldEnum = {
    id: 'id',
    name: 'name',
    state: 'state',
    city: 'city',
    county: 'county',
    zip: 'zip',
    mailingAddress: 'mailingAddress',
    mailingAddressLine2: 'mailingAddressLine2',
    contactName: 'contactName',
    email: 'email',
    phone: 'phone',
    feeStructure: 'feeStructure',
    latitude: 'latitude',
    longitude: 'longitude',
    leadAgencyId: 'leadAgencyId',
    leadAgencyName: 'leadAgencyName',
    paymentMethod: 'paymentMethod',
    t2sValue: 't2sValue',
    submissionNotes: 'submissionNotes',
    requirementDetails: 'requirementDetails',
    additionalComments: 'additionalComments',
    additionaRequirements: 'additionaRequirements',
    additionalFees: 'additionalFees',
    isEmailed: 'isEmailed',
    isCurrent1AsOf2021: 'isCurrent1AsOf2021',
    isMailed: 'isMailed',
    deactivated: 'deactivated',
    isStateSubmits: 'isStateSubmits',
    needsT2sFile: 'needsT2sFile',
    isSubmittedViaPortal: 'isSubmittedViaPortal',
    needsXmlZipFile: 'needsXmlZipFile',
    portalId: 'portalId',
    portalName: 'portalName',
    preferUncertified: 'preferUncertified',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.LinearWebhookEventScalarFieldEnum = {
    id: 'id',
    linearId: 'linearId',
    action: 'action',
    createdAt: 'createdAt',
    data: 'data',
    updatedFrom: 'updatedFrom',
    url: 'url',
    type: 'type',
    organizationId: 'organizationId',
    webhookTimestamp: 'webhookTimestamp'
};
exports.LockScalarFieldEnum = {
    id: 'id',
    type: 'type',
    resourceId: 'resourceId',
    holderId: 'holderId',
    expiresAt: 'expiresAt',
    description: 'description',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.MergeRecordScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    winningId: 'winningId',
    losingId: 'losingId',
    losingData: 'losingData',
    tableName: 'tableName',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.NotificationScalarFieldEnum = {
    id: 'id',
    message: 'message',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    tierIIReportId: 'tierIIReportId',
    submissionId: 'submissionId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.OneSchemaImportScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    templateType: 'templateType',
    templateKey: 'templateKey',
    rawFileKey: 'rawFileKey',
    cleanFileKey: 'cleanFileKey',
    oneSchemaEmbedId: 'oneSchemaEmbedId',
    requestIds: 'requestIds',
    status: 'status',
    processingMethod: 'processingMethod',
    userId: 'userId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.PaymentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    status: 'status',
    paymentMethod: 'paymentMethod',
    amount: 'amount',
    transactionFee: 'transactionFee',
    description: 'description',
    memo: 'memo',
    payee: 'payee',
    paidAt: 'paidAt',
    recordedByEmail: 'recordedByEmail',
    documentId: 'documentId',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    activityId: 'activityId',
    lobMailId: 'lobMailId',
    jobId: 'jobId',
    payeeType: 'payeeType',
    company: 'company',
    addressLine1: 'addressLine1',
    addressLine2: 'addressLine2',
    city: 'city',
    state: 'state',
    zip: 'zip',
    billable: 'billable',
    exceptionNote: 'exceptionNote',
    reconciliationStatus: 'reconciliationStatus',
    reconciledAt: 'reconciledAt',
    reconciledBy: 'reconciledBy'
};
exports.PaymentCommentScalarFieldEnum = {
    id: 'id',
    paymentId: 'paymentId',
    message: 'message',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    deleted: 'deleted',
    deletedAt: 'deletedAt',
    deletedBy: 'deletedBy',
    createdByEmail: 'createdByEmail'
};
exports.PaymentInvoiceScalarFieldEnum = {
    id: 'id',
    payee: 'payee',
    invoiceNumber: 'invoiceNumber',
    invoiceDocumentId: 'invoiceDocumentId',
    dateDue: 'dateDue',
    amount: 'amount',
    description: 'description',
    paymentId: 'paymentId'
};
exports.PaymentReconciliationHistoryScalarFieldEnum = {
    id: 'id',
    paymentId: 'paymentId',
    previousStatus: 'previousStatus',
    newStatus: 'newStatus',
    changedBy: 'changedBy',
    changedByEmail: 'changedByEmail',
    changedAt: 'changedAt'
};
exports.PersonScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    first: 'first',
    last: 'last',
    email: 'email',
    title: 'title',
    company: 'company',
    streetAddress1: 'streetAddress1',
    streetAddress2: 'streetAddress2',
    city: 'city',
    state: 'state',
    zip: 'zip',
    country: 'country',
    phones: 'phones',
    isEncamp: 'isEncamp',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    createdAtViaMerge: 'createdAtViaMerge',
    attentionTo: 'attentionTo',
    dbNumber: 'dbNumber',
    tankOwnerType: 'tankOwnerType'
};
exports.PipelineScalarFieldEnum = {
    id: 'id',
    name: 'name',
    tenantId: 'tenantId',
    lastRunAt: 'lastRunAt',
    inputFiles: 'inputFiles',
    outputFiles: 'outputFiles',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.PoliceDepartmentScalarFieldEnum = {
    id: 'id',
    address: 'address',
    name: 'name',
    additionalComments: 'additionalComments',
    attn: 'attn',
    city: 'city',
    state: 'state',
    zip: 'zip',
    email: 'email',
    contactName: 'contactName',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.PortalScalarFieldEnum = {
    id: 'id',
    type: 'type',
    jurisdiction: 'jurisdiction',
    url: 'url',
    capacity: 'capacity',
    allowsMultiSessionLogin: 'allowsMultiSessionLogin',
    allowsCookieReuse: 'allowsCookieReuse',
    requiresUsageOfChemicalDb: 'requiresUsageOfChemicalDb',
    usesMFA: 'usesMFA',
    supportedProgramAreas: 'supportedProgramAreas',
    description: 'description',
    isActive: 'isActive',
    verifiable: 'verifiable',
    portalTech: 'portalTech',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ProductScalarFieldEnum = {
    id: 'id',
    name: 'name',
    alternateId: 'alternateId',
    reference: 'reference',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ProductChemicalScalarFieldEnum = {
    id: 'id',
    productId: 'productId',
    chemicalId: 'chemicalId',
    amount: 'amount',
    unit: 'unit',
    storageType: 'storageType',
    storageTypeDescription: 'storageTypeDescription',
    pressure: 'pressure',
    temperature: 'temperature',
    otherPressureValue: 'otherPressureValue',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ProductChemicalOverrideScalarFieldEnum = {
    id: 'id',
    productChemicalId: 'productChemicalId',
    jurisdiction: 'jurisdiction',
    storageType: 'storageType',
    storageTypeDescription: 'storageTypeDescription',
    pressure: 'pressure',
    otherPressureValue: 'otherPressureValue',
    temperature: 'temperature'
};
exports.ProductTenantScalarFieldEnum = {
    id: 'id',
    productId: 'productId',
    tenantId: 'tenantId'
};
exports.RoleScalarFieldEnum = {
    id: 'id',
    name: 'name',
    permissions: 'permissions',
    tenantId: 'tenantId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SercAgencyScalarFieldEnum = {
    id: 'id',
    state: 'state',
    recipient: 'recipient',
    email: 'email',
    streetAddress1: 'streetAddress1',
    streetAddress2: 'streetAddress2',
    city: 'city',
    zip: 'zip',
    submitsViaEmail: 'submitsViaEmail',
    submitsViaPortal: 'submitsViaPortal',
    submitsViaForm: 'submitsViaForm',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SnapshotScalarFieldEnum = {
    id: 'id',
    type: 'type',
    sourceId: 'sourceId',
    content: 'content',
    dataModelVersion: 'dataModelVersion',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.StorageLocationScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    description: 'description',
    CA_mapNumber: 'CA_mapNumber',
    CA_gridNumber: 'CA_gridNumber',
    OR_insideOutside: 'OR_insideOutside',
    OR_storageBuilding: 'OR_storageBuilding',
    OR_storageFloor: 'OR_storageFloor',
    OR_storageArea: 'OR_storageArea',
    OR_storageRoom: 'OR_storageRoom',
    OR_storageQuadrant: 'OR_storageQuadrant',
    NV_insideOutside: 'NV_insideOutside',
    latitude: 'latitude',
    longitude: 'longitude',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilitySubmissionScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    submissionId: 'submissionId',
    isExempt: 'isExempt',
    exemptionReason: 'exemptionReason',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SubmissionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    title: 'title',
    submissionType: 'submissionType',
    status: 'status',
    encampStatus: 'encampStatus',
    requirementStatus: 'requirementStatus',
    recipient: 'recipient',
    submissionMethod: 'submissionMethod',
    reportingPeriodStart: 'reportingPeriodStart',
    reportingPeriodEnd: 'reportingPeriodEnd',
    dueDate: 'dueDate',
    submittedAt: 'submittedAt',
    staffAssigneeId: 'staffAssigneeId',
    reviewRequired: 'reviewRequired',
    reviewMode: 'reviewMode',
    signedAt: 'signedAt',
    signatureType: 'signatureType',
    notes: 'notes',
    metadata: 'metadata',
    requirementJurisdictions: 'requirementJurisdictions',
    source: 'source',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SubmissionDocumentScalarFieldEnum = {
    id: 'id',
    submissionId: 'submissionId',
    documentId: 'documentId',
    documentSource: 'documentSource',
    reviewRequired: 'reviewRequired',
    type: 'type',
    externalDocumentId: 'externalDocumentId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SubmissionDocumentReviewScalarFieldEnum = {
    id: 'id',
    submissionReviewerId: 'submissionReviewerId',
    submissionDocumentId: 'submissionDocumentId',
    reviewerStatus: 'reviewerStatus',
    signatureStatus: 'signatureStatus',
    completedAt: 'completedAt',
    hasViewed: 'hasViewed',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SubmissionPaymentScalarFieldEnum = {
    id: 'id',
    submissionId: 'submissionId',
    paymentId: 'paymentId',
    description: 'description',
    amount: 'amount',
    transactionFeeAmount: 'transactionFeeAmount',
    isRequired: 'isRequired',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SubmissionReviewerScalarFieldEnum = {
    id: 'id',
    submissionId: 'submissionId',
    userId: 'userId',
    reviewOrder: 'reviewOrder',
    isStaff: 'isStaff',
    isRequired: 'isRequired',
    isSigner: 'isSigner',
    dueDate: 'dueDate',
    completedAt: 'completedAt',
    signerNameOverride: 'signerNameOverride',
    signerEmailOverride: 'signerEmailOverride',
    streetAddress1: 'streetAddress1',
    streetAddress2: 'streetAddress2',
    city: 'city',
    state: 'state',
    zip: 'zip',
    country: 'country',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SubmissionTagScalarFieldEnum = {
    id: 'id',
    submissionId: 'submissionId',
    tagId: 'tagId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SupplementalFireDepartmentScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    fireDepartmentId: 'fireDepartmentId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.SupplementalLepcScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    lepcId: 'lepcId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.TagScalarFieldEnum = {
    id: 'id',
    name: 'name',
    description: 'description',
    tenantId: 'tenantId',
    icon: 'icon',
    isDisabled: 'isDisabled',
    isInternal: 'isInternal',
    type: 'type',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    createdBy: 'createdBy'
};
exports.TaskScalarFieldEnum = {
    id: 'id',
    seriesId: 'seriesId',
    title: 'title',
    description: 'description',
    completedAt: 'completedAt',
    reminderDays: 'reminderDays',
    completedById: 'completedById',
    assigneeId: 'assigneeId',
    links: 'links',
    tenantId: 'tenantId',
    submissionId: 'submissionId',
    frequency: 'frequency',
    interval: 'interval',
    endDate: 'endDate',
    startDate: 'startDate',
    excludedDates: 'excludedDates',
    isSuggested: 'isSuggested',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    createdBy: 'createdBy',
    updatedBy: 'updatedBy'
};
exports.SubTaskScalarFieldEnum = {
    id: 'id',
    taskId: 'taskId',
    title: 'title',
    completedAt: 'completedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    createdBy: 'createdBy',
    updatedBy: 'updatedBy'
};
exports.TaskTagScalarFieldEnum = {
    id: 'id',
    tagId: 'tagId',
    taskId: 'taskId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.TenantScalarFieldEnum = {
    id: 'id',
    name: 'name',
    partnerTenantId: 'partnerTenantId',
    salesforceId: 'salesforceId',
    isDemo: 'isDemo',
    isPartner: 'isPartner',
    isDisabled: 'isDisabled',
    externalId: 'externalId',
    roleIdToDefaultForNewUsers: 'roleIdToDefaultForNewUsers',
    ssoMappingName: 'ssoMappingName',
    ssoIssuerUrl: 'ssoIssuerUrl',
    ssoMetadataUrl: 'ssoMetadataUrl',
    ssoDomains: 'ssoDomains',
    signsAllReportPages: 'signsAllReportPages',
    selfSignedCertification: 'selfSignedCertification',
    salesforceSyncedAt: 'salesforceSyncedAt',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.TenantConfigScalarFieldEnum = {
    id: 'id',
    key: 'key',
    value: 'value',
    tenantId: 'tenantId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.TenantContactScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    type: 'type',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    userId: 'userId',
    salesforceContactId: 'salesforceContactId',
    syncedAt: 'syncedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    createdBy: 'createdBy',
    updatedBy: 'updatedBy'
};
exports.ReportFacilityDocumentScalarFieldEnum = {
    id: 'id',
    facilityDocumentId: 'facilityDocumentId',
    tierIIReportId: 'tierIIReportId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.TierIIReportScalarFieldEnum = {
    id: 'id',
    organizationStatus: 'organizationStatus',
    encampStatus: 'encampStatus',
    productCount: 'productCount',
    facilityId: 'facilityId',
    reportingYear: 'reportingYear',
    currentWorkflowId: 'currentWorkflowId',
    tenantId: 'tenantId',
    verifierFullName: 'verifierFullName',
    verifierTitle: 'verifierTitle',
    verifierPhone: 'verifierPhone',
    verifierEmail: 'verifierEmail',
    verifiedAt: 'verifiedAt',
    verifiedByEncamp: 'verifiedByEncamp',
    reportKind: 'reportKind',
    submittedAt: 'submittedAt',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    reasonForReport: 'reasonForReport',
    notesToRegulators: 'notesToRegulators',
    department: 'department',
    fulfillmentNote: 'fulfillmentNote',
    needsRevision: 'needsRevision',
    needsRevisionReason: 'needsRevisionReason',
    touchedSteps: 'touchedSteps',
    touchedCASteps: 'touchedCASteps',
    tags: 'tags',
    reviewCompletedByUserId: 'reviewCompletedByUserId',
    filedBy: 'filedBy',
    portalReportId: 'portalReportId',
    requiresReviewers: 'requiresReviewers'
};
exports.TierIIReportAssigneeScalarFieldEnum = {
    id: 'id',
    tierIIReportId: 'tierIIReportId',
    personId: 'personId',
    assignmentType: 'assignmentType',
    isComplete: 'isComplete',
    completedAt: 'completedAt',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.TierIIReportPaymentScalarFieldEnum = {
    paymentId: 'paymentId',
    tierIIReportId: 'tierIIReportId',
    amount: 'amount',
    transactionFeeAmount: 'transactionFeeAmount'
};
exports.TierIIReportStatusLogScalarFieldEnum = {
    id: 'id',
    tierIIReportId: 'tierIIReportId',
    statusType: 'statusType',
    status: 'status',
    timestamp: 'timestamp',
    statusUpdatedBy: 'statusUpdatedBy',
    createdAt: 'createdAt',
    createdBy: 'createdBy'
};
exports.TierIIReportSubmissionMeasureScalarFieldEnum = {
    id: 'id',
    index: 'index',
    name: 'name',
    description: 'description',
    startedAt: 'startedAt',
    completedAt: 'completedAt',
    notes: 'notes',
    records: 'records',
    tierIIReportId: 'tierIIReportId'
};
exports.TierIIReportUstStatusScalarFieldEnum = {
    tierIIReportId: 'tierIIReportId',
    undergroundStorageTankId: 'undergroundStorageTankId',
    touchedSteps: 'touchedSteps'
};
exports.TierIIReportValidationScalarFieldEnum = {
    id: 'id',
    errors: 'errors',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    tierIIReportId: 'tierIIReportId'
};
exports.UndergroundStorageTankScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    tankId: 'tankId',
    nickname: 'nickname',
    typeOfAction: 'typeOfAction',
    manufacturer: 'manufacturer',
    capacityGallons: 'capacityGallons',
    installationDate: 'installationDate',
    existingDiscoveredDate: 'existingDiscoveredDate',
    permanentlyClosedDate: 'permanentlyClosedDate',
    configuration: 'configuration',
    numberOfCompartments: 'numberOfCompartments',
    additionalDescription: 'additionalDescription',
    tankUsage: 'tankUsage',
    tankUsageOther: 'tankUsageOther',
    tankContents: 'tankContents',
    tankContentsOther: 'tankContentsOther',
    type: 'type',
    constructionPrimaryContainment: 'constructionPrimaryContainment',
    constructionPrimaryContainmentOther: 'constructionPrimaryContainmentOther',
    constructionSecondaryContainment: 'constructionSecondaryContainment',
    constructionSecondaryContainmentOther: 'constructionSecondaryContainmentOther',
    overfillProtection: 'overfillProtection',
    pipingConstruction: 'pipingConstruction',
    pipingSystemType: 'pipingSystemType',
    productWastePrimaryContainment: 'productWastePrimaryContainment',
    productWastePrimaryContainmentOther: 'productWastePrimaryContainmentOther',
    productWasteSecondaryContainment: 'productWasteSecondaryContainment',
    productWasteSecondaryContainmentOther: 'productWasteSecondaryContainmentOther',
    pipingTurbineContainmentSump: 'pipingTurbineContainmentSump',
    ventPrimaryContainment: 'ventPrimaryContainment',
    ventPrimaryContainmentOther: 'ventPrimaryContainmentOther',
    ventSecondaryContainment: 'ventSecondaryContainment',
    ventSecondaryContainmentOther: 'ventSecondaryContainmentOther',
    vaporRecoveryPrimaryContainment: 'vaporRecoveryPrimaryContainment',
    vaporRecoveryPrimaryContainmentOther: 'vaporRecoveryPrimaryContainmentOther',
    vaporRecoverySecondaryContainment: 'vaporRecoverySecondaryContainment',
    vaporRecoverySecondaryContainmentOther: 'vaporRecoverySecondaryContainmentOther',
    riserPipePrimaryContainment: 'riserPipePrimaryContainment',
    riserPipePrimaryContainmentOther: 'riserPipePrimaryContainmentOther',
    riserPipeSecondaryContainment: 'riserPipeSecondaryContainment',
    riserPipeSecondaryContainmentOther: 'riserPipeSecondaryContainmentOther',
    ventPipingTransitionSumps: 'ventPipingTransitionSumps',
    fillComponentsInstalled: 'fillComponentsInstalled',
    constructionType: 'constructionType',
    constructionMaterial: 'constructionMaterial',
    constructionMaterialOther: 'constructionMaterialOther',
    corrosionProtection: 'corrosionProtection',
    monitoringEquipmentServiced: 'monitoringEquipmentServiced',
    monitoringEquipmentServicedOther: 'monitoringEquipmentServicedOther',
    sitePlotPlanSubmitted: 'sitePlotPlanSubmitted',
    udcMonitoring: 'udcMonitoring',
    udcMonitoringOther: 'udcMonitoringOther',
    udcPanelManufacturer: 'udcPanelManufacturer',
    udcPanelModel: 'udcPanelModel',
    udcLeakSensorManufacturer: 'udcLeakSensorManufacturer',
    udcLeakSensorModel: 'udcLeakSensorModel',
    hasUdcLeakDetection: 'hasUdcLeakDetection',
    hasUdcLeakAlarmTriggerShutdown: 'hasUdcLeakAlarmTriggerShutdown',
    hasUdcFailureTriggerShutdown: 'hasUdcFailureTriggerShutdown',
    hasUdcMonitoringStopFlow: 'hasUdcMonitoringStopFlow',
    udcConstruction: 'udcConstruction',
    udcSecondaryContactMonitoring: 'udcSecondaryContactMonitoring',
    hasUdcSecondaryLeakDetection: 'hasUdcSecondaryLeakDetection',
    periodicSystemTesting: 'periodicSystemTesting',
    recordKeeping: 'recordKeeping',
    ustPersonnelFamiliarTraining: 'ustPersonnelFamiliarTraining',
    otherTrainingDocuments: 'otherTrainingDocuments',
    designatedOperatorTraining: 'designatedOperatorTraining',
    additionalInformation: 'additionalInformation',
    firstNameResponsibility: 'firstNameResponsibility',
    firstNameTitle: 'firstNameTitle',
    secondNameResponsibility: 'secondNameResponsibility',
    secondNameTitle: 'secondNameTitle',
    tankMonitoringMethod: 'tankMonitoringMethod',
    continuousElectronicTankMonitoringSecondaryContainmentSystem: 'continuousElectronicTankMonitoringSecondaryContainmentSystem',
    continuousElectronicTankMonitoringEmpManufacturer: 'continuousElectronicTankMonitoringEmpManufacturer',
    continuousElectronicTankMonitoringEmpModelNumber: 'continuousElectronicTankMonitoringEmpModelNumber',
    continuousElectronicTankMonitoringLeakSensorManufacturer: 'continuousElectronicTankMonitoringLeakSensorManufacturer',
    continuousElectronicTankMonitoringLeakSensorModelNumber: 'continuousElectronicTankMonitoringLeakSensorModelNumber',
    automaticTankGaugingAtgPanelManufacturer: 'automaticTankGaugingAtgPanelManufacturer',
    automaticTankGaugingAtgModelNumber: 'automaticTankGaugingAtgModelNumber',
    automaticTankGaugingProbeManufacturer: 'automaticTankGaugingProbeManufacturer',
    automaticTankGaugingProbeModelNumber: 'automaticTankGaugingProbeModelNumber',
    automaticTankGaugingLeakTestFrequency: 'automaticTankGaugingLeakTestFrequency',
    automaticTankGaugingLeakTestFrequencyOther: 'automaticTankGaugingLeakTestFrequencyOther',
    automaticTankGaugingProgrammedTankTests: 'automaticTankGaugingProgrammedTankTests',
    automaticTankGaugingProgrammedTankTestsOther: 'automaticTankGaugingProgrammedTankTestsOther',
    weeklyManualTankGaugeGaugingTestPeriod: 'weeklyManualTankGaugeGaugingTestPeriod',
    integrityTestingFrequency: 'integrityTestingFrequency',
    integrityTestingFrequencyOther: 'integrityTestingFrequencyOther',
    otherMonitoring: 'otherMonitoring',
    pipeMonitoringMethod: 'pipeMonitoringMethod',
    pipeSecContainmentMonitoringPipingSecondaryContainment: 'pipeSecContainmentMonitoringPipingSecondaryContainment',
    pipeSecContainmentMonitoringPanelManufacturer: 'pipeSecContainmentMonitoringPanelManufacturer',
    pipeSecContainmentMonitoringPanelModelNumber: 'pipeSecContainmentMonitoringPanelModelNumber',
    pipeSecContainmentMonitoringLeakSensorManufacturer: 'pipeSecContainmentMonitoringLeakSensorManufacturer',
    pipeSecContainmentMonitoringLeakSensorModelNumber: 'pipeSecContainmentMonitoringLeakSensorModelNumber',
    pipeSecContainmentMonitoringLeakAlarmTriggersAutoPumpShutdown: 'pipeSecContainmentMonitoringLeakAlarmTriggersAutoPumpShutdown',
    pipeSecContainmentMonitoringFailureTriggersPumpShutdown: 'pipeSecContainmentMonitoringFailureTriggersPumpShutdown',
    mechanicalLineLeakDetectorManufacturer: 'mechanicalLineLeakDetectorManufacturer',
    mechanicalLineLeakDetectorModelNumber: 'mechanicalLineLeakDetectorModelNumber',
    electronicLineLeakDetectorManufacturer: 'electronicLineLeakDetectorManufacturer',
    electronicLineLeakDetectorModelNumber: 'electronicLineLeakDetectorModelNumber',
    electronicLineLeakDetectorProgrammedInlineTesting: 'electronicLineLeakDetectorProgrammedInlineTesting',
    electronicLineLeakDetectorTriggersAutoPumpShutdown: 'electronicLineLeakDetectorTriggersAutoPumpShutdown',
    electronicLineLeakDetectorFailureTriggersPumpShutdown: 'electronicLineLeakDetectorFailureTriggersPumpShutdown',
    pipelineIntegrityTestingFrequency: 'pipelineIntegrityTestingFrequency',
    pipelineIntegrityTestingFrequencyOther: 'pipelineIntegrityTestingFrequencyOther',
    visualPipelineMonitoringFrequency: 'visualPipelineMonitoringFrequency',
    otherPipelineMonitoring: 'otherPipelineMonitoring',
    previouslyReported: 'previouslyReported',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.UndergroundStorageTankCertificationScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    certifiedWork: 'certifiedWork',
    certifiedWorkPermit: 'certifiedWorkPermit',
    certifiedWorkDescription: 'certifiedWorkDescription',
    contractorName: 'contractorName',
    contractorLicenseNumber: 'contractorLicenseNumber',
    contractorICCCertificationNumber: 'contractorICCCertificationNumber',
    certifierName: 'certifierName',
    certifierTitle: 'certifierTitle',
    certifierPhoneNumber: 'certifierPhoneNumber',
    certifierEmployer: 'certifierEmployer',
    certifierRelationToTankOwner: 'certifierRelationToTankOwner',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.UserScalarFieldEnum = {
    id: 'id',
    email: 'email',
    type: 'type',
    invitedAt: 'invitedAt',
    invitationExpiresAt: 'invitationExpiresAt',
    status: 'status',
    personId: 'personId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.UserCalendarTokenScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    token: 'token',
    createdAt: 'createdAt',
    lastUsedAt: 'lastUsedAt'
};
exports.UserCognitoScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    cognitoSub: 'cognitoSub'
};
exports.UserFacilityScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    userId: 'userId'
};
exports.UserLoginScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    loginAt: 'loginAt'
};
exports.UserTenantScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    roleId: 'roleId'
};
exports.FacilityWasteStreamScalarFieldEnum = {
    id: 'id',
    facilityId: 'facilityId',
    wasteStreamHashKey: 'wasteStreamHashKey',
    dotDescription: 'dotDescription',
    classification: 'classification',
    federalWasteCodes: 'federalWasteCodes',
    stateWasteCodes: 'stateWasteCodes',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityWasteStreamAmountScalarFieldEnum = {
    id: 'id',
    facilityWasteStreamId: 'facilityWasteStreamId',
    month: 'month',
    amountInPounds: 'amountInPounds',
    originalUnit: 'originalUnit',
    originalUnitAmount: 'originalUnitAmount',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.FacilityWasteStreamYearToDateScalarFieldEnum = {
    id: 'id',
    year: 'year',
    managementMethodCodes: 'managementMethodCodes',
    finalDestinations: 'finalDestinations',
    shipments: 'shipments',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    facilityWasteStreamId: 'facilityWasteStreamId'
};
exports.IngestSummaryScalarFieldEnum = {
    id: 'id',
    s3Key: 's3Key',
    facilitiesUpdated: 'facilitiesUpdated',
    rcraCodesCreated: 'rcraCodesCreated',
    wasteTransportersCreated: 'wasteTransportersCreated',
    wasteDisposalFacilitiesCreated: 'wasteDisposalFacilitiesCreated',
    wasteStreamsCreated: 'wasteStreamsCreated',
    wasteStreamsUpdated: 'wasteStreamsUpdated',
    manifestsCreated: 'manifestsCreated',
    manifestsUpdated: 'manifestsUpdated',
    manifestLineItemsCreated: 'manifestLineItemsCreated',
    manifestLineItemsUpdated: 'manifestLineItemsUpdated',
    owner: 'owner',
    createdAt: 'createdAt',
    createdBy: 'createdBy'
};
exports.StateWasteCodeScalarFieldEnum = {
    id: 'id',
    state: 'state',
    value: 'value',
    definition: 'definition',
    classification: 'classification',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteLineUnifiedScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    epaId: 'epaId',
    vendorSiteId: 'vendorSiteId',
    manifestTrackingNumber: 'manifestTrackingNumber',
    processedManifestId: 'processedManifestId',
    wasteStreamRawId: 'wasteStreamRawId',
    shippedDate: 'shippedDate',
    wasteLineNumber: 'wasteLineNumber',
    willNotReport: 'willNotReport',
    manuallyEdited: 'manuallyEdited',
    vendorManifestId: 'vendorManifestId',
    vendorManifestUpdatedDate: 'vendorManifestUpdatedDate',
    vendorProfileNumber: 'vendorProfileNumber',
    vendorDotIdNumberDescription: 'vendorDotIdNumberDescription',
    vendorDotPrintedInformation: 'vendorDotPrintedInformation',
    vendorNonHazWasteDescription: 'vendorNonHazWasteDescription',
    vendorFederalWasteCodes: 'vendorFederalWasteCodes',
    vendorStateWasteCodes: 'vendorStateWasteCodes',
    vendorManagementMethodCode: 'vendorManagementMethodCode',
    vendorManagementMethodDescription: 'vendorManagementMethodDescription',
    vendorFormCode: 'vendorFormCode',
    vendorFormCodeDescription: 'vendorFormCodeDescription',
    vendorSourceCode: 'vendorSourceCode',
    vendorSourceCodeDescription: 'vendorSourceCodeDescription',
    vendorWasteMinimizationCode: 'vendorWasteMinimizationCode',
    vendorWasteMinimizationDescription: 'vendorWasteMinimizationDescription',
    vendorConsentNumber: 'vendorConsentNumber',
    vendorDotHazardous: 'vendorDotHazardous',
    vendorEpaWaste: 'vendorEpaWaste',
    vendorWasteResidue: 'vendorWasteResidue',
    vendorClassification: 'vendorClassification',
    vendorAmount: 'vendorAmount',
    vendorProfileDescription: 'vendorProfileDescription',
    vendorComments: 'vendorComments',
    originalVendorProfileDescription: 'originalVendorProfileDescription',
    originalVendorDotPrintedInformation: 'originalVendorDotPrintedInformation',
    originalVendorNonHazWasteDescription: 'originalVendorNonHazWasteDescription',
    originalVendorAmount: 'originalVendorAmount',
    originalVendorProfileNumber: 'originalVendorProfileNumber',
    originalVendorManagementMethodCode: 'originalVendorManagementMethodCode',
    originalVendorFormCode: 'originalVendorFormCode',
    originalVendorSourceCode: 'originalVendorSourceCode',
    eManifestId: 'eManifestId',
    eManifestUpdatedDate: 'eManifestUpdatedDate',
    eManifestProfileNumber: 'eManifestProfileNumber',
    eManifestDotIdNumberDescription: 'eManifestDotIdNumberDescription',
    eManifestDotPrintedInformation: 'eManifestDotPrintedInformation',
    eManifestNonHazWasteDescription: 'eManifestNonHazWasteDescription',
    eManifestFederalWasteCodes: 'eManifestFederalWasteCodes',
    eManifestStateWasteCodes: 'eManifestStateWasteCodes',
    eManifestManagementMethodCode: 'eManifestManagementMethodCode',
    eManifestManagementMethodDescription: 'eManifestManagementMethodDescription',
    eManifestFormCode: 'eManifestFormCode',
    eManifestFormCodeDescription: 'eManifestFormCodeDescription',
    eManifestSourceCode: 'eManifestSourceCode',
    eManifestSourceCodeDescription: 'eManifestSourceCodeDescription',
    eManifestWasteMinimizationCode: 'eManifestWasteMinimizationCode',
    eManifestWasteMinimizationDescription: 'eManifestWasteMinimizationDescription',
    eManifestConsentNumber: 'eManifestConsentNumber',
    eManifestDotHazardous: 'eManifestDotHazardous',
    eManifestEpaWaste: 'eManifestEpaWaste',
    eManifestWasteResidue: 'eManifestWasteResidue',
    eManifestAmount: 'eManifestAmount',
    eManifestComments: 'eManifestComments',
    tagIds: 'tagIds',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteLineUnifiedTagScalarFieldEnum = {
    id: 'id',
    tagId: 'tagId',
    wasteLineUnifiedId: 'wasteLineUnifiedId',
    wasteLineUnifiedShippedDate: 'wasteLineUnifiedShippedDate',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteManifestVendorScalarFieldEnum = {
    id: 'id',
    name: 'name',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteStreamScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    name: 'name',
    classification: 'classification',
    internalNote: 'internalNote',
    comment: 'comment',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WasteStreamRawScalarFieldEnum = {
    id: 'id',
    wasteStreamHashKey: 'wasteStreamHashKey',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    epaId: 'epaId',
    vendorSiteId: 'vendorSiteId',
    wasteStreamId: 'wasteStreamId',
    name: 'name',
    eManifestProfileNumber: 'eManifestProfileNumber',
    vendorProfileNumber: 'vendorProfileNumber',
    classification: 'classification',
    federalWasteCodes: 'federalWasteCodes',
    stateWasteCodes: 'stateWasteCodes',
    managementMethodCode: 'managementMethodCode',
    formCode: 'formCode',
    sourceCode: 'sourceCode',
    wasteMinimizationCode: 'wasteMinimizationCode',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ActivityScalarFieldEnum = {
    id: 'id',
    type: 'type',
    status: 'status',
    executionPlan: 'executionPlan',
    description: 'description',
    output: 'output',
    reportDetailsExtended: 'reportDetailsExtended',
    championId: 'championId',
    nonChampionIds: 'nonChampionIds',
    cohortFacilityIds: 'cohortFacilityIds',
    assigneeId: 'assigneeId',
    workflowId: 'workflowId',
    currentJobId: 'currentJobId',
    lobMailId: 'lobMailId',
    message: 'message',
    cohortTypes: 'cohortTypes',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    tier2SubmitValidationStatus: 'tier2SubmitValidationStatus',
    tier2SubmitValidationErrors: 'tier2SubmitValidationErrors',
    tier2SubmitValidationWarnings: 'tier2SubmitValidationWarnings'
};
exports.ActivityLogScalarFieldEnum = {
    id: 'id',
    activityId: 'activityId',
    status: 'status',
    message: 'message',
    errorType: 'errorType',
    stackTrace: 'stackTrace',
    time: 'time'
};
exports.ActivityUserInputScalarFieldEnum = {
    id: 'id',
    activityId: 'activityId',
    label: 'label',
    shortName: 'shortName',
    type: 'type',
    value: 'value',
    required: 'required',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ActivityCohortScalarFieldEnum = {
    id: 'id',
    activityId: 'activityId',
    cohortId: 'cohortId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ActivityDocumentScalarFieldEnum = {
    activityId: 'activityId',
    documentId: 'documentId'
};
exports.WorkflowScalarFieldEnum = {
    id: 'id',
    type: 'type',
    name: 'name',
    description: 'description',
    status: 'status',
    completedAt: 'completedAt',
    version: 'version',
    graph: 'graph',
    history: 'history',
    currentActivityId: 'currentActivityId',
    tierIIReportId: 'tierIIReportId',
    cohortId: 'cohortId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WorkflowManagerConfigScalarFieldEnum = {
    id: 'id',
    type: 'type',
    value: 'value',
    notes: 'notes',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.WorkflowTagScalarFieldEnum = {
    id: 'id',
    workflowId: 'workflowId',
    tagId: 'tagId',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ZipCodeScalarFieldEnum = {
    id: 'id',
    stateFips: 'stateFips',
    stateFullName: 'stateFullName',
    state: 'state',
    zip: 'zip',
    county: 'county',
    city: 'city',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy'
};
exports.ChemicalAnomalyScalarFieldEnum = {
    tenantId: 'tenantId',
    reportingYear: 'reportingYear',
    facilityName: 'facilityName',
    facilityId: 'facilityId',
    chemicalName: 'chemicalName',
    chemicalId: 'chemicalId',
    previousYearMaxAmount: 'previousYearMaxAmount',
    previousYearUnit: 'previousYearUnit',
    previousYearReportId: 'previousYearReportId',
    currentYearMaxAmount: 'currentYearMaxAmount',
    currentYearUnit: 'currentYearUnit',
    currentYearReportId: 'currentYearReportId',
    changeType: 'changeType',
    percentageChange: 'percentageChange'
};
exports.EchoExporterAggregatedScalarFieldEnum = {
    registryId: 'registryId',
    echoFacilityName: 'echoFacilityName',
    facilityStreet: 'facilityStreet',
    facilityCity: 'facilityCity',
    facilityState: 'facilityState',
    facilityZip: 'facilityZip',
    facilityCounty: 'facilityCounty',
    facActiveFlag: 'facActiveFlag',
    airFlag: 'airFlag',
    npdesFlag: 'npdesFlag',
    rcraFlag: 'rcraFlag',
    triFlag: 'triFlag',
    echoFacilityNaicsCodes: 'echoFacilityNaicsCodes',
    echoFirstNaicsCode: 'echoFirstNaicsCode',
    facComplianceStatus: 'facComplianceStatus',
    violationStatuteCodes: 'violationStatuteCodes',
    penaltyStatuteCodes: 'penaltyStatuteCodes',
    nonComplianceCountLast12Qrtrs: 'nonComplianceCountLast12Qrtrs',
    violationCountLast12Qrtrs: 'violationCountLast12Qrtrs',
    penaltiesLast12Qrtrs: 'penaltiesLast12Qrtrs',
    rcraHistoricalCompliance: 'rcraHistoricalCompliance',
    cwaHistoricalCompliance: 'cwaHistoricalCompliance',
    caaHistoricalCompliance: 'caaHistoricalCompliance',
    rcraIds: 'rcraIds',
    npdesIds: 'npdesIds',
    pgmSysIds: 'pgmSysIds'
};
exports.ProcessedManifestViewScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    facilityId: 'facilityId',
    manifestTrackingNumber: 'manifestTrackingNumber',
    eManifestId: 'eManifestId',
    vendorManifestId: 'vendorManifestId',
    hasIssues: 'hasIssues',
    hasIssuesReason: 'hasIssuesReason',
    shippedDate: 'shippedDate',
    epaId: 'epaId',
    destinationFacilityId: 'destinationFacilityId',
    destinationFacilityName: 'destinationFacilityName',
    receivedDate: 'receivedDate',
    vendorSource: 'vendorSource',
    eManifestCreatedDate: 'eManifestCreatedDate',
    eManifestCertifiedDate: 'eManifestCertifiedDate',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    updatedAt: 'updatedAt',
    updatedBy: 'updatedBy',
    isRegulatedEManifest: 'isRegulatedEManifest',
    receivedByTsdf: 'receivedByTsdf',
    eManifestDaysInTransit: 'eManifestDaysInTransit',
    wasteLineCount: 'wasteLineCount'
};
exports.FacilityEPAIdsScalarFieldEnum = {
    facilityId: 'facilityId',
    epaId: 'epaId',
    currentWasteGeneratorStatus: 'currentWasteGeneratorStatus',
    receiveDate: 'receiveDate'
};
exports.FacilityEchoExporterScalarFieldEnum = {
    key: 'key',
    facilityId: 'facilityId',
    encampFacilityName: 'encampFacilityName',
    echoFacilityName: 'echoFacilityName',
    facilityStatus: 'facilityStatus',
    tenantId: 'tenantId',
    customerFacilityId: 'customerFacilityId',
    naicsCode: 'naicsCode',
    naics3: 'naics3',
    registryId: 'registryId',
    echoFacilityNaicsCodes: 'echoFacilityNaicsCodes',
    echoFirstNaicsCode: 'echoFirstNaicsCode',
    facActiveFlag: 'facActiveFlag',
    airFlag: 'airFlag',
    npdesFlag: 'npdesFlag',
    rcraFlag: 'rcraFlag',
    triFlag: 'triFlag',
    facComplianceStatus: 'facComplianceStatus',
    facilityStreet: 'facilityStreet',
    facilityCity: 'facilityCity',
    facilityState: 'facilityState',
    facilityZip: 'facilityZip',
    facilityCounty: 'facilityCounty',
    violationStatuteCodes: 'violationStatuteCodes',
    penaltyStatuteCodes: 'penaltyStatuteCodes',
    nonComplianceCountLast12Qrtrs: 'nonComplianceCountLast12Qrtrs',
    violationCountLast12Qrtrs: 'violationCountLast12Qrtrs',
    penaltiesLast12Qrtrs: 'penaltiesLast12Qrtrs',
    rcraHistoricalCompliance: 'rcraHistoricalCompliance',
    cwaHistoricalCompliance: 'cwaHistoricalCompliance',
    caaHistoricalCompliance: 'caaHistoricalCompliance',
    rcraIds: 'rcraIds',
    npdesIds: 'npdesIds',
    pgmSysIds: 'pgmSysIds'
};
exports.FacilityRCRAInfoExporterScalarFieldEnum = {
    facilityId: 'facilityId',
    handlerId: 'handlerId',
    currentWasteGeneratorStatus: 'currentWasteGeneratorStatus',
    receiveDate: 'receiveDate'
};
exports.FacilityTierIIReportScalarFieldEnum = {
    viewId: 'viewId',
    tierIIReportId: 'tierIIReportId',
    productCount: 'productCount',
    reportingYear: 'reportingYear',
    reportKind: 'reportKind',
    encampStatus: 'encampStatus',
    organizationStatus: 'organizationStatus',
    tenantId: 'tenantId',
    tenantName: 'tenantName',
    facilityId: 'facilityId',
    customerFacilityId: 'customerFacilityId',
    facilityName: 'facilityName',
    facilityDateClosed: 'facilityDateClosed',
    facilityDateInactive: 'facilityDateInactive',
    facilityTagNames: 'facilityTagNames',
    facilityStatus: 'facilityStatus',
    state: 'state',
    streetAddress1: 'streetAddress1',
    streetAddress2: 'streetAddress2',
    city: 'city',
    county: 'county',
    zip: 'zip',
    isInactive: 'isInactive',
    isClosed: 'isClosed',
    colocationReportingFacilityId: 'colocationReportingFacilityId',
    isNotReporting: 'isNotReporting',
    isNotReportingThroughEncamp: 'isNotReportingThroughEncamp',
    organizationStatusAnnual: 'organizationStatusAnnual',
    encampStatusAnnual: 'encampStatusAnnual',
    hasOpenRevision: 'hasOpenRevision',
    hasVerifiedRevision: 'hasVerifiedRevision',
    hasOpenInitial: 'hasOpenInitial',
    hasVerifiedInitial: 'hasVerifiedInitial',
    reportUpdatedAt: 'reportUpdatedAt',
    reportUpdatedBy: 'reportUpdatedBy',
    reportCreatedAt: 'reportCreatedAt',
    reportCreatedBy: 'reportCreatedBy',
    issueCount: 'issueCount',
    chemicalFeatureFlagOverride: 'chemicalFeatureFlagOverride',
    filedOn: 'filedOn'
};
exports.SnapshotReportingFacilityChemicalScalarFieldEnum = {
    id: 'id',
    sourceId: 'sourceId',
    facilityId: 'facilityId',
    reportingYear: 'reportingYear',
    rfc_content: 'rfc_content',
    unit: 'unit',
    chemical_id: 'chemical_id',
    chemical_name: 'chemical_name',
    chemical_is_ehs: 'chemical_is_ehs',
    chemical_cas_number: 'chemical_cas_number',
    chemical_alternate_id: 'chemical_alternate_id',
    maxAmount: 'maxAmount',
    averageAmount: 'averageAmount',
    isOverThreshold: 'isOverThreshold',
    reporting_status: 'reporting_status'
};
exports.TierIIReportActivityScalarFieldEnum = {
    id: 'id',
    tierIIReportId: 'tierIIReportId',
    productCount: 'productCount',
    reportingYear: 'reportingYear',
    reportKind: 'reportKind',
    encampStatus: 'encampStatus',
    jobStatus: 'jobStatus',
    organizationStatus: 'organizationStatus',
    tenantId: 'tenantId',
    tenantIsDemo: 'tenantIsDemo',
    tenantIsDisabled: 'tenantIsDisabled',
    organizationName: 'organizationName',
    facilityId: 'facilityId',
    facilityName: 'facilityName',
    facilityChemicalFeatureFlagOverride: 'facilityChemicalFeatureFlagOverride',
    customerFacilityId: 'customerFacilityId',
    cersId: 'cersId',
    state: 'state',
    streetAddress1: 'streetAddress1',
    streetAddress2: 'streetAddress2',
    city: 'city',
    zip: 'zip',
    county: 'county',
    lepcId: 'lepcId',
    lepcName: 'lepcName',
    fdId: 'fdId',
    fdName: 'fdName',
    hasIncompleteReviews: 'hasIncompleteReviews',
    tags: 'tags',
    issueCount: 'issueCount',
    filedOn: 'filedOn',
    workflowId: 'workflowId',
    workflowStatus: 'workflowStatus',
    workflowName: 'workflowName',
    workflowDescription: 'workflowDescription',
    graph: 'graph',
    activityId: 'activityId',
    activityType: 'activityType',
    activityDescription: 'activityDescription',
    activityExecutionPlan: 'activityExecutionPlan',
    activityStatus: 'activityStatus',
    activityErrorMessage: 'activityErrorMessage',
    activityAssigneeId: 'activityAssigneeId',
    activityAssigneeEmail: 'activityAssigneeEmail',
    activityAssigneeFirst: 'activityAssigneeFirst',
    activityAssigneeLast: 'activityAssigneeLast',
    isChampionReport: 'isChampionReport',
    cohortChampionIds: 'cohortChampionIds',
    partnerTenant: 'partnerTenant'
};
exports.SortOrder = {
    asc: 'asc',
    desc: 'desc'
};
exports.NullableJsonNullValueInput = {
    DbNull: exports.DbNull,
    JsonNull: exports.JsonNull
};
exports.JsonNullValueInput = {
    JsonNull: exports.JsonNull
};
exports.QueryMode = {
    default: 'default',
    insensitive: 'insensitive'
};
exports.JsonNullValueFilter = {
    DbNull: exports.DbNull,
    JsonNull: exports.JsonNull,
    AnyNull: exports.AnyNull
};
exports.NullsOrder = {
    first: 'first',
    last: 'last'
};
//# sourceMappingURL=prismaNamespaceBrowser.js.map